<template>
  <div class="guestInfo">
    <div class="stateroomDetail-t stateroomDetail-t2 js-returnDetailBtn">
      <a class="stateroomDetail-returnButton" @click="goBack">
        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png" />
      </a>
      <p class="stateroomDetail-t-title">乘客信息</p>
    </div>
    <div class="list-block media-list" :class="{'bottom-deposit': order.isDownPayCruise}" id="guestInfoPage">
      <template v-if="allowUseTikTokCode">
        <div class="guest-header is-tiktok" style="padding-top: 6px">
          <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
          <div class="row-1">您正在完成抖音团购核销申请</div>
          <div class="row-2">请于<span>{{ countDownText }}</span>内完成以下信息信息填写。提交后会尽快为您完成审核。</div>
          <div class="row-2">（预计48小时内完成审核）</div>
        </div>
      </template>
      <template v-else>
        <!--开航日45天前既可以使用订金预订又可以进行快速预订-->
        <template v-if="order.isDownPayCruise">
          <div class="guest-header" style="padding-top: 6px">
            <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
            <div class="row-1">恭喜您！获得<em>订金预订特权</em></div>
            <div class="row-2">请于<span>{{ countDownText }}</span>内完成填写。</div>
          </div>
        </template>
        <!--开航日45天-14天前仅可使用快速预订，不可进行订金预订-->
        <template v-else-if="!order.isDownPayCruise && order.isAllowQuickOrder">
          <div class="guest-header" style="padding-top: 6px">
            <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
            <div class="row-1">恭喜您！获得<em>快速预订特权</em></div>
            <div class="row-2">每舱仅需填<em>1位</em>乘客即可锁定心仪房型。请于<span>{{ countDownText }}</span>内完成填写。</div>
          </div>
        </template>
        <!--开航日前14天以内无法使用任何订金以及快速预订-->
        <template v-else>
          <div class="guest-header">
            <img class="logo" style="margin-top: 5px" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
            <div class="row-0"><em>恭喜您锁定心仪舱房</em>，请于<span>{{ countDownText }}</span>内完成以下信息填写。</div>
          </div>
        </template>
      </template>

      <!--倒计时-->
      <!--      <div class="countDownCon">-->
      <!--        <div class="countDownCon-txt">-->
      <!--          我们为您保留房间，剩余时间<span class="countDownTime">{{-->
      <!--            countDownText-->
      <!--          }}</span-->
      <!--          >，请尽快完成预订。<br />-->
      <!--          这个旅程超棒，赶快下单不让自己遗憾！-->
      <!--        </div>-->
      <!--      </div>-->

      <!--航线-->
      <div class="route-info">
        <div class="route-name">
          <div class="route-name-icon">
            <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon01.png" />
          </div>
          <div class="route-name-txt">
            {{ order.cruiseName }}
          </div>
        </div>

        <div class="route-ship">
          {{ order.sailDays }}天{{ order.sailDays - 1 }}晚 {{ order.shipName }}
        </div>
        <div class="route-row">
          <div class="route-row-txt">
            {{ order.sailDateBegin }} - {{ order.sailDateEnd }}
          </div>
        </div>
      </div>

      <div class="cruiseInfo">
        <div class="label-checkbox item-content guestsList-title">
          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title item-contactTitel contactEdit">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/contact-icon.png" />
                <span>联系人</span>用于行程相关短信/邮件接收
              </div>
              <div class="item-after item-contactEditTxt" @click="showContactList('contact', '')">
                <span>创建/选择联系人</span>
                <img class="profilePicEdit contactEdit"
                  src="https://resource.rcclchina.com.cn/mobileSearchPackage/right-icon.png" />
              </div>
            </div>
          </div>
        </div>
        <!--!contactsList && contactsList.length===0-->
        <div class="contactInfo" v-if="contactsList.length === 0">
          <div class="contactInfo-main">
            <div class="item-contactInput">
              <span class="item-contactInputTxt">中文姓</span>
              <input type="text" v-model="bookingContact.chineseLastName" class="contactName" name="contactName"
                placeholder="请输入中文姓" />
            </div>
            <div class="item-contactInput">
              <span class="item-contactInputTxt">中文名</span>
              <input type="text" v-model="bookingContact.chineseFirstName" class="contactName" name="contactName"
                placeholder="请输入中文名" />
              <div style="width: 50px" class="send-verification" @click="chineseToPinyin">
                <span>转拼音</span>
              </div>
            </div>
            <div class="item-contactInput">
              <span class="item-contactInputTxt">拼音姓</span>
              <input type="text" v-model="bookingContact.pinyinLastName" class="contactName" name="contactName"
                placeholder="请输入拼音姓" />
            </div>
            <div class="item-contactInput">
              <span class="item-contactInputTxt">拼音名</span>
              <input type="text" v-model="bookingContact.pinyinFirstName" class="contactName" name="contactName"
                placeholder="请输入拼音名" />
            </div>
            <div class="item-contactInput" :class="!needShowSmsCode ? 'noNeedPhone' : ''">
              <span class="item-contactInputTxt">手机号</span>
              <input type="text" v-model="bookingContact.telephone" class="contactTelephone" name="contactTelephone"
                placeholder="请输入手机号" />
            </div>
            <div class="js-verify item-contactInput indentifying-code" v-show="needShowSmsCode">
              <span class="item-contactInputTxt">验证码</span>
              <input placeholder="请输入验证码" type="text" v-model="picCode" id="indentifyingCode" class="indentifyingCode"
                name="indentifyingCode" maxlength="4" />
              <div class="codeImg contactPicCode">
                <img :src="picCodeImage" @click="getPicCode" />
              </div>
            </div>
            <div class="js-verify item-contactInput verification-code" v-show="needShowSmsCode" style="width: 278px">
              <span class="item-contactInputTxt">短信验证码</span>
              <input placeholder="请输入短信验证码" type="text" v-model="smsCode" class="shortMessageVerificationCode"
                name="shortMessageVerificationCode" style="width: 100%" />
              <div class="send-verification" style="right: -68px;left: auto" @click="onSmsClick">
                <span>{{ smsCodeText }}</span>
              </div>
            </div>
            <div class="item-contactInput" style="width: 278px">
              <span class="item-contactInputTxt">电子邮箱</span>
              <input type="text" v-model="bookingContact.email" placeholder="请输入电子邮箱" class="contactEmail"
                name="contactEmail" style="width: 100%" />
            </div>
          </div>
          <div class="item-saveContacts" @click="saveConcat">
            保存联系人
          </div>
        </div>
        <div v-else class="contactInfoList">
          <div class="contact-main">
            <div class="contact-item" v-show="gIdx <= 4" v-for="(g, gIdx) in contactsList" :key="gIdx"
              @click="setSelectedGuestId(g, gIdx)" :class="{ 'selected': gIdx === selectedGuestIdx }">
              <span v-if="g.chineseLastName || g.chineseFirstName">{{ g.chineseLastName }}{{ g.chineseFirstName }}</span>
              <span v-else>{{ g.pinyinLastName }}{{ g.pinyinFirstName }}</span>
              <div class="selectedImg"><img
                  src="https://resource.rcclchina.com.cn/mobileSearchPackage/contact-active.png" alt=""></div>
            </div>
          </div>
        </div>
        <div class="contactInfo-filled" v-if="selectedContact" @click="showContactList('contact', '')">
          <div class="contactInfo-name">
            <span v-if="selectedContact.chineseLastName || selectedContact.chineseFirstName">{{
              selectedContact.chineseLastName || '' }}{{ selectedContact.chineseFirstName || '' }}</span>
            <span v-else>{{ selectedContact.pinyinLastName }}{{ selectedContact.pinyinFirstName }}</span>
            <div class="contactInfo-phone" v-if="selectedContact.telephone">{{ selectedContact.telephone }}</div>
          </div>
          <div class="contactInfo-email" v-if="selectedContact.telephone">
            {{ selectedContact.email }}
            <div>
              <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/edit-contact.png" alt="">
            </div>
          </div>
        </div>
        <div class="contactInfo" style="width: 100%" v-if="contactsList.length > 0 && needShowSmsCode">
          <div class="contactInfo-main">
            <div class="js-verify item-contactInput indentifying-code" style="padding-top: 0;">
              <span class="item-contactInputTxt" style="width: 60px">验证码</span>
              <input placeholder="请输入验证码" type="text" v-model="picCode" id="indentifyingCode" class="indentifyingCode"
                     name="indentifyingCode" maxlength="4" />
              <div class="codeImg contactPicCode" style="left: 170px">
                <img :src="picCodeImage" @click="getPicCode" />
              </div>
            </div>
            <div class="js-verify item-contactInput verification-code">
              <span class="item-contactInputTxt" style="width: 60px">短信验证码</span>
              <input placeholder="请输入短信验证码" type="text" v-model="smsCode" class="shortMessageVerificationCode"
                     name="shortMessageVerificationCode" />
              <div class="send-verification" style="right: -68px;left: auto" @click="onSmsClick">
                <span>{{ smsCodeText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bookingIntegrals > 0">
        <PointGiveaway :isImproveInfo="isFinishSelfInfo" :point="bookingIntegrals" @editInfo="editInfo"></PointGiveaway>
      </div>
      <!--舱房-->
      <div class="cruiseRoomsCon">
        <div class="cruiseRoomsCon-prompTitle">
          <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tipIcon.png" alt="" />
          <span>我们高度重视您的个人信息的保护。请查阅<a href="/Rccl.UserCenter/Privacy">隐私政策</a>以了解我们的个人信息处理规则。</span>
        </div>
        <!--        <div class="cruiseRoomsCon-prompTitle">-->
        <!--          <img-->
        <!--            src="https://resource.rcclchina.com.cn/mobileSearchPackage/tipIcon.png"-->
        <!--          />-->
        <!--          <span>-->
        <!--            提示：每间舱房需有1名22周岁及以上成人，所有客人必须持有在航次结束后仍有6个月以上有效期的护照。-->
        <!--          </span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="cruiseRoomsCon-prompTitle"-->
        <!--          v-if="userDetail && !isLocalReward"-->
        <!--        >-->
        <!--          <img-->
        <!--            src="https://resource.rcclchina.com.cn/mobileSearchPackage/tipIcon.png"-->
        <!--          />-->
        <!--          <span>-->
        <!--            提示：加入<router-link :to="localRewardLink"-->
        <!--          >皇家游享荟</router-link-->
        <!--          >并完善信息，方可获得丰厚船票预订积分和会员专属福利。-->
        <!--          </span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="cruiseRoomsCon-prompTitle"-->
        <!--          v-else-if="userDetail && !isFinishSelfInfo"-->
        <!--        >-->
        <!--          <img-->
        <!--            src="https://resource.rcclchina.com.cn/mobileSearchPackage/tipIcon.png"-->
        <!--          />-->
        <!--          <span-->
        <!--          >提示：皇家游享荟会员本人需-->
        <!--            <router-link :to="completeInfoLink"> 完善信息 </router-link>-->
        <!--            并准确录入乘客本人护照号，方可获得会员积分，每间舱房仅有1人可获得积分。</span-->
        <!--          >-->
        <!--        </div>-->
        <!--        <div class="cruiseRoomsCon-prompTitle">-->
        <!--          <img-->
        <!--            src="https://resource.rcclchina.com.cn/mobileSearchPackage/tipIcon.png"-->
        <!--          />-->
        <!--          <span style="line-height: 22px">提示：同一航次，同一乘客不可重复添加</span>-->
        <!--        </div>-->

        <!-- 连通房 -->
        <div id="c_connect_detail" class="cruiseRoomsCon-roomDetail" v-if="connectBookings.length == 2">
          <div class="cruiseRoomsCon-roomLists c_content" v-for="(booking, i) in connectBookings"
            :key="'connectBooking_' + i">
            <div class="label-checkbox item-content">
              <div class="item-inner" style="padding-right: 0px">
                <div class="connectBooking-title">
                  <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/connect-icon.png" alt="">
                  连通房{{ i === 0 ? 'A' : 'B' }}
                  <div class="unsubscribePay unsubscribeOpenBtn" @click="showNrpPopup(booking)">
                    {{ getNrpTitle(booking) }}
                  </div>
                </div>
                <div class="item-title-row">
                  <div class="item-title cruiseRoomsCon-roomTxt">
                    <span>{{ getStateroomName(booking) }}</span>

                  </div>
                </div>
                <div class="item-title item-text roomDetail-area">
                  可住{{ booking.guestNumber }}人
                  <span>|&nbsp;{{ getStateroom(booking).floorInfo }}&nbsp;|&nbsp;舱房{{ getStateroom(booking).areaInfo
                    }}</span>
                  <span>&nbsp;|&nbsp;
                    <span class="booking__stateroom_shelterProba" data-area="无">{{ getBalconyArea(booking)
                      }}</span></span>&nbsp;
                </div>
                <div class="stateroomNumber" :style="!booking.stateroomNumberRemark ? 'margin-bottom:6px;' : ''">
                  <div class="stateroomNumber-left">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-room-icon.png" alt="">
                  </div>
                  <div class="stateroomNumber-center">
                    <div v-if="booking.stateroomNumber !== 'GTY'">楼层：<span>{{ booking.deckNumber }}</span></div>
                    <div>房间号：<span>
                        {{ booking.stateroomNumber == "GTY" ? "随机" : booking.stateroomNumber }}</span>
                    </div>
                  </div>
                  <template v-if="order.showDeckImg == true">
                    <div v-if="booking.stateroomNumber != 'GTY'" class="stateroomNumber-right"
                      @click="showBookingDeck(booking.sessionToken)">
                      <div>
                        查看甲板图
                      </div>
                      <div>
                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-right-icon.png" alt="">
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="booking.stateroomNumberRemark" class="stateroomTips">*{{ booking.stateroomNumberRemark }}</div>
                <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                  @click.prevent="isShowQiaohuPopup = true" class="QIAOHU_CSS"
                  src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                <img v-else-if="booking.groupType == 'STARRYSKY'" @click.prevent="isShowStarrySkyPopup = true"
                  class="STARRYSKY_CSS" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                <img v-else-if="booking.groupType == 'PCPGIFT'"
                     @click.prevent="openCustomThemePopup(booking.stateroomPartRecord.personalizedStateroomInfo)"
                     class="PCP_GIFT_THEME_CSS" :src="booking.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage"/>
                <img v-else-if="booking.groupType == 'CUSTOM'"
                     @click.prevent="openCustomThemePopup(booking.stateroomPartRecord.personalizedStateroomInfo)"
                     class="CUSTOM_THEME_CSS" :src="booking.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage"/>

                <div class="roomDetail-tips">
                  <p>*同一航次，同一乘客不可重复添加</p>
<!--                  <p>*每间舱房需要有1名{{ageLimit}}周岁及以上成人</p>-->
                  <p>*所有客人需持有航次结束后仍有6个月以上有效期的护照</p>
                </div>
              </div>
            </div>

            <div>
              <div class="roomDetail-passenger">
                <div class="roomDetail-passenger-main">
                  <div class="passenger-main-title">
                    <div class="title-tips">
                      出行乘客<!--<span>乘客信息需与护照一致</span>-->
                    </div>
                    <div class="title-right" @click="showContactList('guest', booking.sessionToken)">创建/选择乘客 <img
                        src="https://resource.rcclchina.com.cn/mobileSearchPackage/right-icon.png" alt=""></div>
                  </div>
                  <div class="title-desc">乘客信息需与护照一致; 线上改名<span>第一位</span>乘客不可变更</div>
                  <div class="contactInfoList">
                    <div class="contact-main">
                      <div class="contact-item" v-show="gIdx <= 4" v-for="(g, gIdx) in booking.guestsList" :key="gIdx"
                        @click="changeGuest(g, booking, i)" :class="{ 'selected': g.isActive }">
                        <span v-if="g.chineseLastName || g.chineseFirstName">{{ g.chineseLastName || ''
                          }}{{ g.chineseFirstName
                          || ''}}</span>
                        <span v-else>{{ g.pinyinLastName }}{{ g.pinyinFirstName }}</span>
                        <div class="selectedImg"><img
                            src="https://resource.rcclchina.com.cn/mobileSearchPackage/contact-active.png" alt=""></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(guest, j) in booking.guestPersons" :key="'normalBooking_' + i + '_guest_' + j"
                  class="guest-main">
                  <div class="guest-select-main">
                    乘客{{ j + 1 }}
                    <div class="guest-select-checkbox" @click="addCommonGuest(j, booking)">
                      <img v-if="!guest.isCommonUseContact"
                        src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-noSelected.png" alt="">
                      <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-selected.png" alt="">
                      添加为常用乘客
                    </div>
                    <span class="clearGuest" @click="clearGuest(j, booking)">清空</span>
                  </div>
                  <div class="passenger-detail-desc">
                    <div class="passenger-content" @click="showCountry(i, j, booking)">
                      <div class="passenger-family">国家或地区</div>
                      <div class="passenger-txt nationality-txt">
                        <div class="css_nationality js_nationality passenger-country">{{ getCountryName(guest.country) }}
                          <div class="passenger-arrow-right">
                            <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/passenger-right-icon.png"
                              alt="">
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="passenger-content">
                      <div class="passenger-family passenger-title-short">中文姓</div>
                      <div class="passenger-txt">
                        <input type="text" v-model="guest.chineseLastName" @change="onChangeGuestInfo(guest, booking)"
                          name="chinese-family" :placeholder="getCountryArea(guest.country) ? '须与护照一致' : '选填'"
                          id="chinese-family" class="chinese-family">
                      </div>
                      <div class="passenger-family passenger-title-short">中文名</div>
                      <div class="passenger-txt">
                        <input type="text" v-model="guest.chineseFirstName" @change="onChangeGuestInfo(guest, booking)"
                          name="chinese-name" :placeholder="getCountryArea(guest.country) ? '须与护照一致' : '选填'"
                          id="chinese-name" class="chinese-name">
                      </div>
                      <div class="send-verification" @click="passengerChineseToPinyin(guest)">
                        <span>转拼音</span>
                      </div>
                    </div>
                    <div class="passenger-content">
                      <div class="passenger-family passenger-title-short">拼音姓</div>
                      <div class="passenger-txt">
                        <input type="text" placeholder="须与护照一致" v-model="guest.pinyinLastName"
                          @change="onChangeGuestInfo(guest, booking)" name="family-pinyin" id="family-pinyin"
                          class="family-pinyin">
                      </div>
                      <div class="passenger-family passenger-title-short">拼音名</div>
                      <div class="passenger-txt">
                        <input type="text" placeholder="须与护照一致" v-model="guest.pinyinFirstName"
                          @change="onChangeGuestInfo(guest, booking)" name="name-pinyin" id="name-pinyin"
                          class="name-pinyin">
                      </div>
                    </div>
                    <div class="passenger-content">
                      <div class="passenger-birthDate">
                        <div class="passenger-family">出生日期</div>
                        <div class="passenger-txt">
                          <input :ref="'connectDteOfBirthInput_' + i + '_' + j"
                            @click.stop="showDatePicker('connectDteOfBirthInput_' + i + '_' + j)" readonly
                            placeholder="请选择出生日期" @change="onChangeGuestInfo(guest, booking, $event)"
                            :value="guest.dateOfBirth" name="birth-date" id="birth-date" class="birth-date">
                          <div class="passenger-arrow-right">
                            <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/passenger-right-icon.png"
                              alt="">
                          </div>
                        </div>
                      </div>
                      <div class="passenger-sex">
                        <div class="passenger-family">性别</div>
                        <div class="passenger-txt passenger-male">
                          <div class="male-txt" @click="onGenderChange('M', j, booking)">
                            <img v-if="(guest.gender == 'M' || guest.gender == '男')"
                              src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png" alt="">
                            <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
                              alt="">
                            <span>男</span>
                          </div>
                          <div class="female-txt" @click="onGenderChange('F', j, booking)"
                            :class="{ active: (guest.gender == 'F' || guest.gender == '女') }">
                            <img v-if="(guest.gender == 'F' || guest.gender == '女')"
                              src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png" alt="">
                            <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
                              alt="">
                            <span>女</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul v-if="order.isAllowQuickOrder" class="roomDetail-infoFillTips">
              <li>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" />
                <div>至少添加<em class="fc-red">1</em>位乘客，该乘客请勿重复添加，提交后不可修改</div>
              </li>
              <li>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" />
                <div>同行乘客信息（建议开航<em class="fc-red">45</em>天前至“我的订单”补全，开航前<em class="fc-red">7</em>天及以内不可再进行修改）</div>
              </li>
            </ul>
            <div style="padding: 0 12px">
              <guest-info-special-booking v-if="
                specialBookingInfoView.specialBookingViewModels &&
                specialBookingInfoView.specialBookingViewModels.length > 0
              " :specialBookingInfo="specialBookingInfoView" :booking="booking" :order="order"
                :onConfirmSpecial="onConfirmSpecial" />
            </div>
            <div v-if="allowUseTikTokCode" class="tiktok-coupon-box">
              <div class="title-box">
                <img class="icon" src="https://resource.rcclchina.com.cn/tikTok/mb/verification/icon-tikTok.png"
                  alt="" />
                <div class="text">
                  <div>抖音订单号</div>
                </div>
              </div>
              <input v-model="booking.tikTokCouponCode" class="input-text" maxlength="25"
                @blur="checkCanApplyByCouponCode(booking)" />
            </div>

            <div class="item-inner coupon-item-inner">
              <div class="item-title-row" @click="changeCouponShow(i + normalBookings.length)">
                <div class="item-title roomDetail-coupon">
                  <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/couponIcon.png" /><span>使用优惠</span>
                </div>
                <div class="item-after item-roomCoupon couponShowBtn">
                  <span
                    class="coupon-toggle-arrow"
                    :class="{ active: isCouponShow[i + normalBookings.length] }"
                    aria-hidden="true"
                  ></span>
                </div>
              </div>
              <div class="item-couponCon" v-show="isCouponShow[i + normalBookings.length]">
                <div class="item-couponSelectCon">
                  <span>优惠券（选填）</span>
                  <div class="item-couponSelect">
                    <select class="item-couponSelists couponCodeS" @change="
                      onCouponCodeSelected($event, booking.sessionToken)
                      ">
                      <option value="">不选择优惠券</option>
                      <option :selected="booking.couponCode == coupon.token" :value="coupon.token"
                        v-for="(coupon, i) in coupons" :key="'coupon_' + i">
                        {{ coupon.promotion }}
                      </option>
                    </select>
                    <span class="coupon-select-arrow" aria-hidden="true"></span>
                  </div>
                </div>
                <div class="item-activityNum">
                  <span>活动码（选填）</span>
                  <input type="text" placeholder="请输入活动码" v-model="booking.tempPublicCouponCode" class="publicCouponCode"
                    @change="addPublicCouponCode($event, booking.sessionToken)" />
                </div>
              </div>
            </div>
            <!--            <div v-if="i == 1 && booking.stateroomNumber != 'GTY'" style="margin-bottom: 14px" class="lookDeckImg" @click="showBookingDeck(booking.sessionToken)">-->
            <!--              <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/lookDeck-icon.png" alt="">-->
            <!--              查看甲板图-->
            <!--            </div>-->
            <!--            <img-->
            <!--              class="c_img_info"-->
            <!--              data-shipcode="SC"-->
            <!--              data-saildate="2021-02-07"-->
            <!--              v-if="i == 0"-->
            <!--              src="https://resource.rcclchina.com.cn/cruiseDetail/mb_connect_info.png"-->
            <!--            />-->
            <PcpGiftView v-if="booking.groupType==='PCPGIFT'"
                         :giftInfo="booking.stateroomPartRecord?.personalizedStateroomInfo"
                         :shipCode="booking.shipCode"
                         :sailDate="booking.sailDate"
                         :guestNumber="booking.guestNumber"
                         :booking="booking"
                         page-name="GuestInfo"
                         :stateroomIndex="i"></PcpGiftView>
            <div class="c_cutoff" v-if="i == 0"></div>
          </div>
        </div>

        <!-- 普通/巧虎房 -->
        <div id="" class="cruiseRoomsCon-roomDetail" v-if="normalBookings.length > 0">
          <div v-for="(booking, i) in normalBookings" :key="'normalBooking_' + i">
            <div class="label-checkbox item-content">
              <div class="item-inner" style="padding-right: 0px">
                <div class="item-title-row">
                  <div class="item-title cruiseRoomsCon-roomTxt">
                    <span>{{ getStateroomName(booking) }}</span>
                    <div class="unsubscribePay unsubscribeOpenBtn" @click="showNrpPopup(booking)">
                      {{ getNrpTitle(booking) }}
                    </div>
                  </div>
                </div>
                <div class="item-title item-text roomDetail-area">
                  可住{{ booking.guestNumber }}人
                  <span>|&nbsp;{{ getStateroom(booking).floorInfo }}&nbsp;|&nbsp;舱房{{ getStateroom(booking).areaInfo
                    }}</span>
                  <span>&nbsp;|&nbsp;
                    <span class="booking__stateroom_shelterProba" data-area="无">{{ getBalconyArea(booking)
                      }}</span></span>&nbsp;
                </div>
                <div class="stateroomNumber" :style="!booking.stateroomNumberRemark ? 'margin-bottom:6px;' : ''">
                  <div class="stateroomNumber-left">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-room-icon.png" alt="">
                  </div>
                  <div class="stateroomNumber-center">
                    <div v-if="booking.stateroomNumber !== 'GTY'">楼层：<span>{{ booking.deckNumber }}</span></div>
                    <div>房间号：<span>
                        {{ booking.stateroomNumber == "GTY" ? "随机" : booking.stateroomNumber }}</span>
                    </div>
                  </div>
                  <template v-if="order.showDeckImg == true">
                    <div v-if="booking.stateroomNumber != 'GTY'" class="stateroomNumber-right"
                      @click="onChangeStateroomClick(booking.sessionToken)">
                      <div>
                        房号随心选
                      </div>
                      <div>
                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-right-icon.png" alt="">
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="booking.stateroomNumberRemark" class="stateroomTips">*{{ booking.stateroomNumberRemark }}</div>
                <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                  @click.prevent="isShowQiaohuPopup = true" class="QIAOHU_CSS"
                  src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                <img v-else-if="booking.groupType == 'STARRYSKY'" @click.prevent="isShowStarrySkyPopup = true"
                  class="STARRYSKY_CSS" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                <img v-else-if="booking.groupType == 'PCPGIFT'"
                     @click.prevent="openCustomThemePopup(booking.stateroomPartRecord.personalizedStateroomInfo)"
                     class="PCP_GIFT_THEME_CSS" :src="booking.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage">
                <img v-else-if="booking.groupType == 'CUSTOM'"
                     @click.prevent="openCustomThemePopup(booking.stateroomPartRecord.personalizedStateroomInfo)"
                     class="CUSTOM_THEME_CSS" :src="booking.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage">

                <div class="roomDetail-tips">
                  <p>*同一航次，同一乘客不可重复添加</p>
<!--                  <p>*每间舱房需要有1名{{ageLimit}}周岁及以上成人</p>-->
                  <p>*所有客人需持有航次结束后仍有6个月以上有效期的护照</p>
                </div>
              </div>
            </div>
            <div>
              <div class="roomDetail-passenger">
                <div class="roomDetail-passenger-main">
                  <div class="passenger-main-title">
                    <div class="title-tips">
                      出行乘客<!--<span>乘客信息需与护照一致</span>-->
                    </div>
                    <div class="title-right" @click="showContactList('guest', booking.sessionToken)">创建/选择乘客 <img
                        src="https://resource.rcclchina.com.cn/mobileSearchPackage/right-icon.png" alt=""></div>
                  </div>
                  <div class="title-desc">乘客信息需与护照一致; 线上改名<span>第一位</span>乘客不可变更</div>
                  <div class="contactInfoList" v-if="booking.guestsList && booking.guestsList.length > 0">
                    <div class="contact-main">
                      <div class="contact-item" v-show="gIdx <= 4" v-for="(g, gIdx) in booking.guestsList" :key="gIdx"
                        @click="changeGuest(g, booking)" :class="{ 'selected': g.isActive }">
                        <span v-if="g.chineseLastName || g.chineseFirstName">{{ g.chineseLastName ||
                          ''}}{{ g.chineseFirstName
                          || ''}}</span>
                        <span v-else>{{ g.pinyinLastName }}{{ g.pinyinFirstName }}</span>
                        <div class="selectedImg"><img
                            src="https://resource.rcclchina.com.cn/mobileSearchPackage/contact-active.png" alt=""></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(guest, j) in booking.guestPersons" :key="'normalBooking_' + i + '_guest_' + j"
                  class="guest-main">
                  <div class="guest-select-main">
                    乘客{{ j + 1 }}
                    <div class="guest-select-checkbox" @click="addCommonGuest(j, booking)">
                      <img v-if="!guest.isCommonUseContact"
                        src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-noSelected.png" alt="">
                      <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-selected.png" alt="">
                      添加为常用乘客
                    </div>
                    <span class="clearGuest" @click="clearGuest(j, booking)">清空</span>
                  </div>
                  <div class="passenger-detail-desc">
                    <div class="passenger-content" @click="showCountry(i, j, booking)">
                      <div class="passenger-family">国家或地区</div>
                      <div class="passenger-txt nationality-txt">
                        <div class="css_nationality js_nationality passenger-country">{{ getCountryName(guest.country) }}
                          <div class="passenger-arrow-right">
                            <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/passenger-right-icon.png"
                              alt="">
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="passenger-content">
                      <div class="passenger-family passenger-title-short">中文姓</div>
                      <div class="passenger-txt">
                        <input type="text" v-model="guest.chineseLastName" @change="onChangeGuestInfo(guest, booking)"
                          name="chinese-family" :placeholder="getCountryArea(guest.country) ? '须与护照一致' : '选填'"
                          id="chinese-family" class="chinese-family">
                      </div>
                      <div class="passenger-family passenger-title-short" >中文名
                      </div>
                      <div class="passenger-txt">
                        <input type="text" v-model="guest.chineseFirstName" name="chinese-name"
                          :placeholder="getCountryArea(guest.country) ? '须与护照一致' : '选填'" id="chinese-name"
                          class="chinese-name" @change="onChangeGuestInfo(guest, booking)">
                      </div>
                      <div class="send-verification" @click="passengerChineseToPinyin(guest)">
                        <span>转拼音</span>
                      </div>
                    </div>
                    <div class="passenger-content">
                      <div class="passenger-family passenger-title-short">拼音姓</div>
                      <div class="passenger-txt">
                        <input type="text" placeholder="须与护照一致" v-model="guest.pinyinLastName"
                          @change="onChangeGuestInfo(guest, booking)" name="family-pinyin" id="family-pinyin"
                          class="family-pinyin">
                      </div>
                      <div class="passenger-family passenger-title-short">拼音名</div>
                      <div class="passenger-txt">
                        <input type="text" placeholder="须与护照一致" v-model="guest.pinyinFirstName"
                          @change="onChangeGuestInfo(guest, booking)" name="name-pinyin" id="name-pinyin"
                          class="name-pinyin">
                      </div>
                    </div>
                    <div class="passenger-content">
                      <div class="passenger-birthDate">
                        <div class="passenger-family">出生日期</div>
                        <div class="passenger-txt">
                          <input :ref="'normalDteOfBirthInput_' + i + '_' + j"
                            @click.stop="showDatePicker('normalDteOfBirthInput_' + i + '_' + j)" readonly
                            placeholder="请选择出生日期" @change="onChangeGuestInfo(guest, booking, $event)"
                            :value="guest.dateOfBirth" class="birth-date">
                          <div class="passenger-arrow-right">
                            <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/passenger-right-icon.png"
                              alt="">
                          </div>
                        </div>
                      </div>
                      <div class="passenger-sex">
                        <div class="passenger-family">性别</div>
                        <div class="passenger-txt passenger-male">
                          <div class="male-txt" @click="onGenderChange('M', j, booking)">
                            <img v-if="(guest.gender == 'M' || guest.gender == '男')"
                              src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png" alt="">
                            <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
                              alt="">
                            <span>男</span>
                          </div>
                          <div class="female-txt" @click="onGenderChange('F', j, booking)"
                            :class="{ active: (guest.gender == 'F' || guest.gender == '女') }">
                            <img v-if="(guest.gender == 'F' || guest.gender == '女')"
                              src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png" alt="">
                            <img v-else src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
                              alt="">
                            <span>女</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul v-if="order.isAllowQuickOrder" class="roomDetail-infoFillTips">
              <li>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" />
                <div>至少添加<em class="fc-red">1</em>位乘客，该乘客请勿重复添加，提交后不可修改</div>
              </li>
              <li>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" />
                <div>同行乘客信息（建议开航<em class="fc-red">45</em>天前至“我的订单”补全，开航前<em class="fc-red">7</em>天及以内不可再进行修改）</div>
              </li>
            </ul>
            <div style="padding: 0 12px">
              <guest-info-special-booking v-if="
                specialBookingInfoView.specialBookingViewModels &&
                specialBookingInfoView.specialBookingViewModels.length > 0
              " :specialBookingInfo="specialBookingInfoView" :booking="booking" :order="order"
                :onConfirmSpecial="onConfirmSpecial" />
            </div>

            <div v-if="allowUseTikTokCode" class="tiktok-coupon-box">
              <div class="title-box">
                <img class="icon" src="https://resource.rcclchina.com.cn/tikTok/mb/verification/icon-tikTok.png"
                  alt="" />
                <div class="text">
                  <div>抖音订单号</div>
                </div>
              </div>
              <input v-model="booking.tikTokCouponCode" class="input-text" maxlength="25" />
            </div>

            <div class="item-inner coupon-item-inner">
              <div class="item-title-row" @click="changeCouponShow(i)">
                <div class="item-title roomDetail-coupon">
                  <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/couponIcon.png" />
                  <span>使用优惠</span>
                </div>
                <div class="item-after item-roomCoupon couponShowBtn">
                  <span
                    class="coupon-toggle-arrow"
                    :class="{ active: isCouponShow[i] }"
                    aria-hidden="true"
                  ></span>
                </div>
              </div>

              <div class="item-couponCon" v-show="isCouponShow[i]">
                <div class="item-couponSelectCon">
                  <span>优惠券（选填）</span>
                  <div class="item-couponSelect">
                    <select class="item-couponSelists couponCodeS" @change="
                      onCouponCodeSelected($event, booking.sessionToken)
                      ">
                      <option value="">不选择优惠券</option>
                      <option :selected="booking.couponCode == coupon.token" :value="coupon.token"
                        v-for="(coupon, i) in coupons" :key="'coupon_' + i">
                        {{ coupon.promotion }}
                      </option>
                    </select>
                    <span class="coupon-select-arrow" aria-hidden="true"></span>
                  </div>
                </div>
                <div class="item-activityNum">
                  <span>活动码（选填）</span>
                  <input type="text" placeholder="请输入活动码" v-model="booking.tempPublicCouponCode" class="publicCouponCode"
                    @change="addPublicCouponCode($event, booking.sessionToken)" />
                </div>
              </div>
            </div>
            <!--            <div  :style="i===0 && normalBookings.length>1?'':'padding-bottom: 14px'" class="lookDeckImg" @click="onChangeStateroomClick(booking.sessionToken)">-->
            <!--              <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/lookDeck-icon.png" alt="">-->
            <!--              查看甲板图/更换房间-->
            <!--            </div>-->
            <PcpGiftView v-if="booking.groupType==='PCPGIFT'"
                         :giftInfo="booking.stateroomPartRecord?.personalizedStateroomInfo"
                         :shipCode="booking.shipCode"
                         :sailDate="booking.sailDate"
                         :guestNumber="booking.guestNumber"
                         :booking="booking"
                         page-name="GuestInfo"
                         :stateroomIndex="i"></PcpGiftView>
            <div class="c_cutoff" v-if="i === 0 && normalBookings.length > 1"></div>
          </div>
        </div>
      </div>

      <!--岸上观光-->
      <template v-if="order.bookingIndex">
        <div class="notice-wrap" v-if="order.bookingIndex.isRow == false">
          <div class="notice js_shorex" :class="{ active: isShorexShow }" @click="isShorexShow = !isShorexShow">
            <div class="notice-line"></div>
            <div class="notice-txt">岸上观光服务</div>
            <div class="notice-arrow">
              <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon15.png" />
            </div>
          </div>

          <div class="shorex" v-show="isShorexShow">
            <div class="notice-item">
              <div class="label-checkbox no-shorex">
                您可以在支付完成后界面选择岸上观光服务，或在船票预订完成后前往皇家行前订网站小程序选订。您也可以不选订任何行程则视为自助游，您需自行安排目的地游览行程。
              </div>
            </div>
          </div>
        </div>
        <!-- ROW调整-等待设计稿 | 等待文案 -->
        <div class="notice-wrap" v-else>
          <div class="notice js_shorex" :class="{ active: isShorexShow }" @click="isShorexShow = !isShorexShow">
            <div class="notice-line"></div>
            <div class="notice-txt">船上产品或服务重要说明</div>
            <div class="notice-arrow">
              <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon15.png" />
            </div>
          </div>

          <div class="shorex" v-show="isShorexShow">
            <div class="notice-item">
              <div class="label-checkbox no-shorex">
                由于技术限制，皇家加勒比国际游轮旗下海外出发航线的船上付费项目暂时无法在皇家行前订官网以及国际官网提前预订和支付（船上付费类项目通常包括：海外目的地的岸上观光，船上各类付费餐饮、娱乐等），请您于登船后进行预订。
              </div>
            </div>
          </div>
        </div>
      </template>

      <!--订单费用与政策须知-->
      <template v-if="order.bookingIndex">
        <GuestInfoPolicy v-if="order.bookings.length > 0" :showBankPopup="showBankPopup"
          :isDownPayCruise="order.isDownPayCruise" 
          :showRow="order.bookingIndex.isRow"
          />
      </template>

      <!-- 结算 -->
      <GuestInfoBottomPrice :allowUseTikTokCode="allowUseTikTokCode" :isDownPayCruise="order.isDownPayCruise"
        :normalBookings="normalBookings" :connectBookings="connectBookings"
        :submitBooking="checkGuestRepeatSubmitBooking" :showPrivacy="showPrivacy" :tabHistory="tabHistory" />
    </div>

    <!-- 联系人列表 -->
    <GuestInfoContactList :onGoBack="closeContactList" :isShow="isShowContactList" :desc-text="guestInfoDesc"
      :maxCount="maxGuestCount" :contactMode="contactMode" :selectContactIds="selectContactIds"
      :onBookingContactConfirm="onBookingContactConfirm" :onGuestContactConfirm="onGuestContactConfirm"
      :closeContactEdit="closeContactEdit" :showContactEdit="showContactEdit"
      :isShowContactEditPopup="isShowContactEdit" @updateContactList="getContactList()" />

    <!-- 更换房间号 -->
    <GuestInfoChangeStateroom :isShow="isShowChangeStateroom" :booking="targetBooking" :cabins="targetCabins"
      :closeChangeStateroom="closeChangeStateroom" :onChangeStateroomConfirm="onChangeStateroomConfirm" />

    <!-- 甲板图 -->
    <BookingDeck :isShow="isShowBookingDeck" :closeBookingDeckPopup="closeBookingDeckPopup"
      :shipCode="targetBooking.shipCode" :sailDate="targetBooking.sailDate" :deckNumber="targetBooking.deckNumber" />

    <!-- 舱房详情 -->
    <StateroomDetail :onGoBack="closeStateroomDetailPopup" :isShow="isShowStateroomDetailPopup"
      :stateroomDetail="selectStateroom" :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise" />

    <!-- 收费/常规退订弹窗 -->
    <NrpPopup :isShow="isShowNrpPopup" :nrpTitle="getNrpTitle(targetBooking)"
      :nrpDescription="getNrpDecription(targetBooking)" :onCloseNrpPopup="closeNrpPopup" />

    <!-- 线下转账 -->
    <BankPopup :onGoBack="closeBankPopup" :isShow="isShowBankPopup" />

    <GuestInfoPrivacy :onGoBack="closePrivacy" :isShow="isShowPrivacy" :changeTab="changePrivacyTab"
      :tab="privacyTab" :showRow="order.bookingIndex ? order.bookingIndex.isRow :false"/>

    <ConnectRoomPopup :onGoBack="closeConnectRoomPopup" :isShow="isShowConnectRoomPopup" />

    <QiaohuPopup :shipCode="shipCode" :sailDate="sailDate" :onGoBack="closeQiaohuPopup" :isShow="isShowQiaohuPopup" />
    <StarrySkyPopup :shipCode="shipCode" :sailDate="sailDate" :onGoBack="closeStarrySkyPopup"
      :isShow="isShowStarrySkyPopup" />
    <CustomThemePopup
        :onGoBack="closeCustomThemePopup"
        :isShow="isShowCustomThemePopup"
        :themeInfo="personalizedStateroomInfo"
    />
    <ReserveConfirmPopup v-if="isShowPromptPopups" @closePromptPopups="closePromptPopups"
      @headCallPrompt="headCallPrompt" :hasNrp="hasNrp" :hasRp="hasRp" :hasOutTime="hasOutTime"
      :contentData="contentData" :cancelPolicy="cancelPolicy" :cancelPolicyNrp="cancelPolicyNrp"></ReserveConfirmPopup>
    <CountrySelector :isShow="isShowCountry" :onCountrySelected="onCountrySelected" :onCountryClose="onCountryClose" />

    <div id="captchaElement"></div>
    <button id="captchaTrigger" type="button" style="display:none"></button>
  </div>
</template>

<script>
import api from "@/api";
import { checkMail, checkPassport, checkTel, differDays, isChinese, isEmpty, isLetter } from "@/utilities/tools";
import nrpConfig from "@/utilities/nrpConfig";
import ReserveConfirmPopup from "@/components/Booking/ReserveConfirmPopup.vue";
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
import CountrySelector from "@/components/Booking/CountrySelector.vue";
import Picker from "pickerjs";
import 'pickerjs/dist/picker.min.css'
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";

const GuestInfoSpecialBooking = () =>
  import("@/components/Booking/GuestInfoSpecialBooking");
const GuestInfoPolicy = () => import("@/components/Booking/GuestInfoPolicy");
const GuestInfoBottomPrice = () =>
  import("@/components/Booking/GuestInfoBottomPrice");
const GuestInfoContactList = () =>
  import("@/components/Booking/GuestInfoContactList");
const GuestInfoChangeStateroom = () =>
  import("@/components/Booking/GuestInfoChangeStateroom");
const BookingDeck = () => import("@/components/Booking/BookingDeck");
const StateroomDetail = () => import("@/components/Booking/StateroomDetail");
const NrpPopup = () => import("@/components/Booking/NrpPopup");
const BankPopup = () => import("@/components/Booking/BankPopup");
const GuestInfoPrivacy = () => import("@/components/Booking/GuestInfoPrivacy");
const QiaohuPopup = () => import("@/components/Cruise/QiaohuPopup");
const ConnectRoomPopup = () => import("@/components/Cruise/ConnectRoomPopup");
const PointGiveaway = () => import("@/components/Booking/PointGiveaway.vue")
const CustomThemePopup =()=> import("@/components/Cruise/CustomThemePopup.vue")
const SCENE_ID = '5v4v21th';
export default {
  name: "GuestInfo",
  components: {
    PcpGiftView,
    CountrySelector,
    StarrySkyPopup,
    ReserveConfirmPopup,
    GuestInfoSpecialBooking,
    GuestInfoPolicy,
    GuestInfoBottomPrice,
    GuestInfoContactList,
    GuestInfoChangeStateroom,
    BookingDeck,
    StateroomDetail,
    NrpPopup,
    BankPopup,
    GuestInfoPrivacy,
    QiaohuPopup,
    ConnectRoomPopup,
    PointGiveaway,
    CustomThemePopup
  },
  props: {},
  beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "乘客信息");
    const self = this;
    // 隐藏头尾
    self.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: true,
      isHideFooter: true,
    });
    self.initPage();
    self.getPicCode();
    window.onpopstate = () => {
      if (self.isShowContactEdit) {
        self.closeContactEdit();
      } else if (self.isShowContactList) {
        self.closeContactList();
      }
      if (self.isShowBankPopup) {
        self.closeBankPopup();
      }
      if (self.isShowStateroomDetailPopup) {
        self.closeStateroomDetailPopup();
      }
      if (self.isShowPrivacy) {
        self.closePrivacy();
      }
      if (self.isShowQiaohuPopup) {
        self.closeQiaohuPopup();
      }
      if (self.isShowConnectRoomPopup) {
        self.closeConnectRoomPopup();
      }
    };
    try {
      if (window && window.gio) {
        const hmsr = this.$store.state.page.trackingCode.hmsr || "";
        if (hmsr.length > 0) {
          window.gio("track", "BF02_GuestInfoPage", { hmsr: hmsr });
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  beforeDestroy() {
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: false,
    });
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
  },
  deactivated() {
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      contentData: '',
      cancelPolicy: '',
      cancelPolicyNrp: '',
      hasNrp: false,
      hasRp: false,
      hasOutTime: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL,
      bookingContact: {
        // name: "",
        callingCode: "",
        chineseFirstName: "",
        chineseLastName: "",
        pinyinLastName: '',
        pinyinFirstName: '',
        country: "CN",
        nationality: "CN",
        dateOfBirth: "",
        email: "",
        gender: "",
        isDefaultContact: false,
        passportExpirationDate: "",
        passportNum: "",
        telephone: "",
      },
      countDown: new Date(),
      countDownText: "",
      countDownTimeout: null,
      userDetail: {},
      contactMode: "contact",
      selectContactIds: [],
      coupons: [],
      isShowContactList: false,
      isShowContactEdit: false,
      isShowChangeStateroom: false,
      isShowBookingDeck: false,
      isShowStateroomDetailPopup: false,
      isShowConnectRoomPopup: false,
      isShowQiaohuPopup: false,
      isShowStarrySkyPopup: false,
      isShowNrpPopup: false,
      isShowBankPopup: false,
      isShowPrivacy: false,
      isShorexShow: true,
      isCouponShow: [true, true, true],
      targetBooking: {},
      targetCabins: [],
      maxGuestCount: 0,
      privacyTab: 0,
      tabHistory: [],
      picCodeImage: "",
      picCode: "",
      smsCode: "",
      smsCodeCountDown: 0,
      selectStateroom: {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        isStarrySky: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        stateroomShelter: "",
        deviceFeatureTags: [],
        deviceGroupTags: []
      },
      differDays: 0,
      bookingsOriginal: null,
      guestInfoDesc: "",
      cruiseId: null,
      tikTokCode: null,
      allowUseTikTokCode: false,
      isShowPromptPopups: false,
      bookingIntegrals: 0,
      isShowMore: false,
      isShowCountry: false,
      guestsList: null,
      selectedGuestIdx: -1,
      bookingIdx: 0,// 订单 表示当前第几个订单
      guestIdx: 0, // 乘客 当前订单下第几个乘客
      contactsList: [],
      selectedContact: {},
      isShowCustomThemePopup: false,
      personalizedStateroomInfo: null,
      marketingFlagChecked: false,

      captcha: null,
      loadingSms:false,
      ageLimit:"18"
    };
  },
  methods: {
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      this.allowUseTikTokCode = JSON.parse(sessionStorage.getItem("isUseTikTokCode"))
      if (!userToken || userToken == "") {
        this.$router.push({
          name: "Login",
          query: {
            returnUrl: location.href,
          },
        });
        return;
      }
      const bookingKey = this.bookingKey;
      if (!bookingKey || bookingKey == "") {
        return this.goBackShoppingCart();
      }
      await this.getContactList()
      // 初始化阿里云
      this.initCaptcha();
      await this.getGuestList()
      const bookingResult = await this.getBookings();

      if (!bookingResult) return;


      this.$loading.show();
      const userDetail = await api.user.getUserDetail(userToken);
      this.$loading.hide();
      if (userDetail.success) {
        this.userDetail = userDetail.data;
        if (
          this.userDetail &&
          this.userDetail.memberLevelStr &&
          this.userDetail.memberLevelStr.length > 0 &&
          this.userDetail.infoIntegrity == 100
        ) {
          // await this.checkSetLocalRewardToFirstGuest(userDetail.data);
        }
      }

      // this.$loading.show();
      // const couponResult = await api.user.getAvailableCoupons(userToken);
      // this.$loading.hide();
      // if (couponResult.success) {
      //   this.coupons = couponResult.data;
      //   this.couponAutoSelect();
      // }

      
      if (this.bookings.some((r) => r.isnrp)) {
        await this.getGuestPolicyByCruise(true)
      }
      if (this.bookings.some((r) => !r.isnrp)) {
        await this.getGuestPolicyByCruise(false)
      }

    },
    // 阿里云验证 start
    // 验证码初始化
    initCaptcha () {
			if (!window.initAliyunCaptcha) return
      window.initAliyunCaptcha({
        SceneId: SCENE_ID,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "popup",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#captchaElement",
        // 触发验证码弹窗或无痕验证的元素
        button: '#captchaTrigger',
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码验证通过回调函数
        success: this.onCaptchaSuccess,
        // 验证码验证不通过回调函数
        fail: this.captchaFail,
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.captcha = instance
        }
      });
		},
    captchaFail() {
      this.loadingSms = false
    },
    onSmsClick() {
      if (this.smsCodeCountDown > 0) {
        return;
      }
      if (this.loadingSms) return
      this.loadingSms = true
      document.getElementById('captchaTrigger').click()
    },
    onCaptchaSuccess(captchaRes) {
      // 刷新
      this.captcha && this.captcha.refresh();
      this.captchaSuccessSms(captchaRes)
    },
    async captchaSuccessSms(captchaVerifyParam) {
      try {
        this.$loading.show();
        await this.sendSmsCode("AliYunAfsNc", captchaVerifyParam);
      } finally {
        this.resetCaptcha()
      }
    },
    resetCaptcha() {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.loadingSms = false
    },
    // 阿里云验证 end

    async getGuestPolicyByCruise(boo) {
      const cruise = await api.user.GetGuestPolicyByCruise({
        CruiseId: this.$store.state.booking.order.cruiseId,
        isNrp: boo,
      });
      // 获取退订策略
      this.isShowPromptPopups = true
      // 1.临近航线政策，2.RP退订政策，3.NRP退订政策
      console.log(cruise, 'cruise')
      if (cruise.data.type == 2) {
        this.hasRp = true
        this.cancelPolicy = cruise.data.body
      } else if (cruise.data.type == 3) {
        this.hasNrp = true
        this.cancelPolicyNrp = cruise.data.body
      } else {
        this.hasOutTime = true
        this.contentData = cruise.data.body
      }
    },
    async getBookings() {
      const { success, data } = await api.booking.guestInfoApi({
        userName: this.$store.state.user.userToken,
        bookingKey: this.bookingKey,
      });
      if (!success || !data.bookings || data.bookings.length == 0) {
        this.goBackShoppingCart();
        return false;
      }

      this.getBookingsGuests(data.bookings)
      this.bookingsOriginal = data.bookings;
      this.differDays = differDays(data.sailDate);
      this.cruiseId = data.cruiseId;
      let integrals = 0
      data.bookings.forEach(booking => {
        if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
          booking.bookingIntegrals.forEach(item => {
            integrals += Number(item.integral)
          })
        }
      })
      data.bookings = this.updateBookings(data.bookings)
      this.bookingIntegrals = integrals
      
      this.$store.commit("SET_BOOKING_FUNNEL_ORDER", data);
      let initDateTime = new Date(data.initDateTime);
      this.countDown = new Date(
        initDateTime.setMinutes(initDateTime.getMinutes() + 13)
      );
      this.setCountDownText();

      if (data.nationalityApiViews && data.nationalityApiViews.length > 0) {
        this.$store.commit("SET_COUNTRIES", data.nationalityApiViews);
      }
      return true;
    },
    updateBookings(bookings) {
      bookings.forEach(booking => {
        booking.contactsList = this.contactsList && this.contactsList.map((r) => {
          return {
            ...r,
            isActive: false
          };
        });

        if(this.selectedGuestIdx<0) {
          let contactList = (this.contactsList && this.contactsList.filter(item => item.isDefaultContact)) || [];
          if(contactList.length === 0) {
            contactList = this.contactsList && this.contactsList.filter(item => item.email && item.telephone)
          }
          let obj = (contactList && contactList.length) ? contactList[0] : {};
          this.contactsList && this.contactsList.forEach((r, rIdx) => {
            if (!isEmpty(obj) && r.id === obj.id) {
              this.selectedGuestIdx = rIdx;
              console.log(rIdx)
              this.selectedContact = r;
              this.bookingContact = r;
            }
          });
        }
        // this.contactsList && this.contactsList.forEach((r, rIdx) => {
        //   if (r.id === booking.contact.id) {
        //     this.selectedGuestIdx = rIdx;
        //     this.selectedContact = r;
        //   }
        // });

        booking.guestsList = this.guestsList && this.guestsList.map((r) => {
          return {
            ...r,
            isActive: false
          };
        });
        const guestMap = new Map();

        booking.guestsList && booking.guestsList.forEach(g => {
          let isCN = this.getCountryArea(g.country)
          let key = `${g.chineseFirstName}-${g.chineseLastName}${g.chineseFirstName}-${g.pinyinFirstName}-${g.pinyinLastName}`;
          if (!isCN) {
            key = `${g.pinyinFirstName}-${g.pinyinLastName}`;
          }
          guestMap.set(key, g);
        });

        booking.guests.guestPersons && booking.guests.guestPersons.forEach((guest) => {
          let isCN = this.getCountryArea(guest.nationality)
          let key = `${guest.firstName}-${guest.name}-${guest.pyFirstName}-${guest.pyLastName}`;
          if (!isCN) {
            key = `${guest.pyFirstName}-${guest.pyLastName}`;
          }
          const targetGuest = guestMap.get(key);
          if (targetGuest) {
            targetGuest.isActive = true;
          }
        });

        if (booking.publicCouponCode) {
          booking.tempPublicCouponCode = booking.publicCouponCode;
        }
      });
      return bookings
    },
    formatRows(rows, tikTokCode) {
      rows && rows.forEach((row) => {
        row.tikTokCampaignCode = tikTokCode;
      });
      return rows
    },
    goBack() {
      this.$router.go(-1);
    },
    // 用户是游享荟会员，并且已经完善信息。如果订单乘客没有填写，把第一个乘客的信息用用户本人信息填上，并触发add guest 接口
    async checkSetLocalRewardToFirstGuest(userDetail) {
      if (this.bookings.length <= 0) return;
      let booking = this.bookings[0];
      this.targetBooking = booking;
      let isGuestEmpty = true;
      if (booking.guests.guestPersons) {
        isGuestEmpty = !booking.guests.guestPersons.some(
          (r) =>
            r.birthDate &&
            r.birthDate.length > 0 &&
            r.firstName &&
            r.firstName.length > 0 &&
            r.lastName &&
            r.lastName.length > 0 &&
            r.pyLastName &&
            r.pyLastName.length > 0 &&
            r.pyFirstName &&
            r.pyFirstName.length > 0
        );
      }

      if (isGuestEmpty) {
        let guest = {};
        guest.pyLastName = userDetail.lastNamePinYin;
        guest.pyFirstName = userDetail.firstNamePinYin;
        guest.lastName = userDetail.lastName;
        guest.firstName = userDetail.firstName;
        guest.birthDate = userDetail.dateOfBirthStr;
        guest.telephone = userDetail.mobile;
        guest.gender = userDetail.gender;
        guest.email = userDetail.email;
        guest.passport = userDetail.passportNo;
        guest.passportExpiresIn = userDetail.passportExpireStr;
        if (
          guest.lastName &&
          guest.lastName.length > 0 &&
          guest.firstName &&
          guest.firstName.length > 0
        ) {
          guest.name = guest.lastName + guest.firstName;
        } else {
          guest.name = `${guest.pyLastName} ${guest.pyFirstName}`;
        }

        await this.addGuestsApi([guest]);
      }
    },
    //验证抖音核销码是否有效
    async checkCanApplyByCouponCode(obj) {
      if (obj.tikTokCouponCode !== '' && obj.tikTokCouponCode.trim() !== '') {
        let { success, errMsg } = await api.tikTok.checkCanApplyByCouponCode({
          TikTokCampaignCode: obj.tikTokCampaignCode,
          TikTokCouponCode: obj.tikTokCouponCode,
          CruiseId: this.cruiseId
        })
        if (!success) {
          this.$alert.show(`【${obj.tikTokCouponCode}】${errMsg}`);
        }
      }
    },
    //选择出生日期
    async showDatePicker(refName) {
      const dateInput = this.$refs[refName];
      if (dateInput && dateInput.length > 0) {
        await this.$nextTick(); // 确保 DOM 更新完成
        new Picker(dateInput[0], {
          format: 'YYYY-MM-DD',
          date: new Date(1980, 0, 1),
          text: {
            title: '请选择出生日期(年/月/日)',
            cancel: '取消',
            confirm: '确认',
          },
        }).show(); // 直接调用 show 方法
      }
    },
    // 显示国家地区选择框
    showCountry(i, j, booking) {
      this.isShowCountry = true
      this.guestIdx = j
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == booking.sessionToken
      );
      if (bookings.length == 0) return;
      this.targetBooking = bookings[0];
    },
    // 选择国家
    onCountrySelected(countryCode) {
      this.targetBooking.guestPersons[this.guestIdx].country = countryCode
      this.onChangeGuestInfo(this.targetBooking.guestPersons[this.guestIdx], this.targetBooking)
      this.isShowCountry = false
    },
    onCountryClose() {
      this.isShowCountry = false
    },
    onGenderChange(gender, j, booking) {
      booking.guestPersons[j].gender = gender
      this.onChangeGuestInfo(booking.guestPersons[j], booking)
    },
    addCommonGuest(j, booking) {
      booking.guestPersons[j].isCommonUseContact = !booking.guestPersons[j].isCommonUseContact
      this.onChangeGuestInfo(booking.guestPersons[j], booking)
    },
    // 选择乘客
    changeGuest(g, booking) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == booking.sessionToken
      );
      if (bookings.length == 0) return;
      this.targetBooking = bookings[0];
      let items = []
      let isCN = this.getCountryArea(g.country)
      booking.guestPersons.forEach(r => {
        if (isCN) {
          if (!isEmpty(r.chineseLastName) || !isEmpty(r.chineseFirstName) || !isEmpty(r.pinyinFirstName) || !isEmpty(r.pinyinLastName)) {
            items.push(r)
          }
        } else {
          if (!isEmpty(r.pinyinFirstName) || !isEmpty(r.pinyinLastName)) {
            items.push(r)
          }
        }
      })
      // console.log('items', items)
      if (items.length === booking.guestNumber && !g.isActive) {
        this.$alert.show("该舱房最多可选" + booking.guestNumber + "名乘客");
        return;
      }
      let currGuestPersons = [...this.targetBooking.guestsList];
      currGuestPersons.forEach((r) => {
        r.isCommonUseContact = true
        if (r.id === g.id) {
          r.isActive = !r.isActive
        }
      })

      const guestsByContactsList = this.getGuestsByContacts(currGuestPersons.filter(r => r.isActive));
      let originalGuests = [];
      let addGuests = [];
      // originalGuests-原始列表
      // addGuests-新增加列表
      // items-已选择的乘客
      // guestsByContactsList-当前的乘客信息列表（顺序会乱）
      items && items.forEach((item)=> {
        guestsByContactsList && guestsByContactsList.forEach((row) => {
          // items和guestsByContactsList中id相同的添加到原始列表（originalGuests）
          if(item.id === row.id) {
            originalGuests.push(row);
          } else {
            // 激活的乘客添加到新增加列表（addGuests）
            if(row.isActive) addGuests.push(row);
          }
        })
      })

      // 合并列表
      let mergeGuests = [...originalGuests, ...addGuests];
      let newGuests = [];
      // 去重
      const seenIds = new Set();
      newGuests = mergeGuests.filter(item => {
        if (seenIds.has(item.id)) {
          return false;
        }
        seenIds.add(item.id);
        return true;
      });

      // const guests = this.getGuestsByContacts(currGuestPersons.filter(r => r.isActive));
      const guests = items && items.length ? newGuests : guestsByContactsList;
      if (guests.length === 0) {
        this.$alert.show("请最少选择一位乘客");
        currGuestPersons.forEach(r => {
          if (r.id === g.id) {
            r.isActive = true
          }
        })
        return;
      } else if (guests.length > booking.guestNumber) {
        this.$alert.show("该舱房最多可选" + booking.guestNumber + "名乘客");
        currGuestPersons.forEach((r) => {
          if (r.id === g.id) {
            r.isActive = false
          }
        })
        return
      }
      if (!this.checkGuest(guests)) {
        currGuestPersons.forEach((r) => {
          r.isCommonUseContact = true
          if (r.id === g.id) {
            r.isActive = !r.isActive
          }
        })
        return;
      }
      this.addGuestsApi(guests);
    },
    // 更新数据进行添加乘客
    async onChangeGuestInfo(g, booking, e = null) {
      // console.log(g,'gggggg');
      // console.log(booking.guestPersons,'booking.guestPersons');

      if (e) {
        g.dateOfBirth = e.target.value
      }
      let isCN = this.getCountryArea(g.country)
      if (isCN) {
        if (!g.chineseFirstName || !g.chineseLastName || !g.dateOfBirth || !g.gender || !g.pinyinFirstName || !g.pinyinLastName) return
      } else {
        if (!g.dateOfBirth || !g.gender || !g.pinyinFirstName || !g.pinyinLastName) return
      }
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == booking.sessionToken
      );
      if (bookings.length == 0) return;
      this.targetBooking = bookings[0];
      booking.selectedGuests = []
      booking.guestPersons.forEach(i => {
        if (this.getCountryArea(i.country)) {
          if (i.chineseFirstName && i.chineseLastName && i.dateOfBirth && i.pinyinFirstName && i.pinyinLastName) {
            booking.selectedGuests.push(i)
          }
        } else {
          if (i.dateOfBirth && i.pinyinFirstName && i.pinyinLastName) {
            booking.selectedGuests.push(i)
          }
        }
      })
      let guests = []
      //console.log(booking.selectedGuests,'booking.selectedGuests');
      
      guests = this.getGuestsByContacts(booking.selectedGuests);

      // console.log(guests,'guestsguests');

      if (!guests || guests.length == 0) return;

      // g.id 为空字符串 findIndex 查找无效 直接全部验证
      if(!g.id){
        if (!this.checkGuest(guests)) return;
      }else{
        const guestIndex = booking.guestPersons.findIndex(guest => guest.id === g.id);
        // console.log('guests', guests, guestIndex)
        if (!this.checkGuest(guests, guestIndex)) return;
      }

      await this.addGuestsApi(guests);
    },
    // 获取联系人列表
    async getContactList(type) {
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        return
      }
      this.$loading.show()
      const { data } = await api.user.getContact(userToken, 1)
      this.$loading.hide()
      if (data && data.length > 0) {
        const contacts = data.filter(item => item.email && item.telephone);
        if (contacts.length === 0) return
        this.contactsList = contacts
        if(type === 'confirmContact') return

        // console.log('contactscontacts', contacts)
        // 如果 selectedContact 不存在，设置为第一个联系人
        if (!this.selectedContact || !this.selectedContact.id) {
          this.selectedContact = contacts[0]
          this.setContactInfo(contacts[0])
        }else {
          let obj = contacts.find(item => item.id === this.selectedContact.id)
          this.selectedContact = obj
          // update乘客信息，已修改的信息
          this.setContactInfo(obj)
        }
      }
    },
    // 获取乘客列表
    async getGuestList() {
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        return
      }
      this.$loading.show()
      const { data } = await api.user.getContact(userToken, 2)
      this.$loading.hide()
      if (data && data.length > 0) {
        this.guestsList = data.filter(item => item.gender && item.dateOfBirth && item.pinyinFirstName && item.pinyinLastName)
      }
    },
    setSelectedGuestId(g, gIdx) {
      this.selectedGuestIdx = gIdx
      this.selectedContact = g
      this.setContactInfo(g)
      this.onBookingContactConfirm(g)
    },
    // 设置联系人信息
    setContactInfo(g) {
      // let name = this.getCountryArea(g.country) ? g.chineseLastName + g.chineseFirstName : g.pinyinLastName + g.pinyinFirstName
      this.bookingContact = {
        // name: name,
        callingCode: g.callingCode,
        chineseFirstName: g.chineseFirstName,
        chineseLastName: g.chineseLastName,
        pinyinLastName: g.pinyinLastName,
        pinyinFirstName: g.pinyinFirstName,
        country: g.country,
        dateOfBirth: g.dateOfBirth,
        email: g.email,
        gender: g.gender,
        isDefaultContact: false,
        passportExpirationDate: g.passportExpirationDate,
        passportNum: g.passportNum,
        telephone: g.telephone,
        id: g.id
      }
      if (this.bookingContact) {
        this.selectContactIds = [this.bookingContact.id];
      } else {
        this.selectContactIds = [];
      }
      // console.log('bookingContact', this.bookingContact)
    },
    clearGuest(j, booking) {
      if (!booking.guests.guestPersons && booking.guests.guestPersons.length <= 0) return
      if (booking.guests.guestPersons[j]) {
        booking.guestsList.forEach(item => {
          if (item.id === booking.guests.guestPersons[j].id) {
            item.isActive = false
          }
        })
      }
      booking.guestPersons[j] = {
        callingCode: "",
        chineseFirstName: "",
        chineseLastName: "",
        pinyinLastName: '',
        pinyinFirstName: '',
        country: "CN",
        dateOfBirth: "",
        email: "",
        gender: "M",
        isDefaultContact: false,
        passportExpirationDate: "",
        passportNum: "",
        telephone: "",
        isCommonUseContact: true
      }
    },
    getBookingsGuests(bookings) {
      // 获取每个乘客填写信息
      bookings && bookings.forEach(booking => {
        booking.guestPersons = []
        for (let i = 0; i < booking.guestNumber; i++) {
          const x = booking.guests.guestPersons && booking.guests.guestPersons[i] || {};
          const newItem = {
            callingCode: "",
            chineseFirstName: x.firstName || "",
            chineseLastName: x.lastName || "",
            pinyinLastName: x.pyLastName || "",
            pinyinFirstName: x.pyFirstName || "",
            country: x.nationality || "CN",
            dateOfBirth: x.birthDate || "",
            email: x.email || "",
            gender: x.gender || "M",
            isDefaultContact: false,
            passportExpirationDate: x.passportExpirationDate || "",
            passportNum: x.passportNum || "",
            telephone: x.telephone || "",
            isCommonUseContact: x.isCommonUseContact,
            id: x.id || "",
          };
          if (newItem.isCommonUseContact === undefined) {
            newItem.isCommonUseContact = true
          }
          booking.guestPersons.push(newItem);
        }
      });
    },

    // 转拼音
    async convertChineseToPinyin(personInfo, alertPrefix) {
      let { chineseFirstName, chineseLastName } = personInfo;

      // 检查是否为空或空字符串
      if (!chineseFirstName || chineseFirstName.trim() === "") {
        this.$alert.show(`${alertPrefix}请填写中文名！`);
        return false;
      }
      if (!chineseLastName || chineseLastName.trim() === "") {
        this.$alert.show(`${alertPrefix}请填写中文姓！`);
        return false;
      }


      if (!isChinese(chineseLastName)) {
        this.$alert.show(`请正确填写${alertPrefix}的中文姓`);
        return false;
      }
      if (!isChinese(chineseFirstName)) {
        this.$alert.show(`请正确填写${alertPrefix}的中文名`);
        return false;
      }



      // 检查长度是否大于0
      if (chineseFirstName.length > 0 || chineseLastName.length > 0) {
        try {
          this.$loading.show();
          const { Success, Data } = await api.user.pyName({ firstName: chineseFirstName, lastName: chineseLastName });
          this.$loading.hide();

          if (Success) {
            personInfo.pinyinLastName = Data.LastName;
            personInfo.pinyinFirstName = Data.FirstName;
          } else {
            this.$alert.show("转换拼音失败，请稍后再试！");
          }
        } catch (error) {
          this.$loading.hide();
          this.$alert.show("网络请求失败，请检查网络连接后重试！");
          console.error("API 请求失败:", error);
        }
      }
    },
    // 乘客中文姓名转拼音
    async passengerChineseToPinyin(booking) {
      await this.convertChineseToPinyin(booking, "乘客信息 - ");
    },
    // 联系人名称转换拼音
    async chineseToPinyin() {
      await this.convertChineseToPinyin(this.bookingContact, "联系人信息 - ");
    },
    async saveConcat() {
      if (!this.saveBookingContact(true)) {
        return;
      }
      // 验证验证码是否填写正确
      if (this.needShowSmsCode && !this.smsCode) {
        this.$alert.show("请填写验证码！");
        return;
      }
      let params = { ...this.bookingContact }
      params.name = `${this.bookingContact.chineseLastName}${this.bookingContact.chineseFirstName}`
      params.firstName = this.bookingContact.chineseFirstName
      params.lastName = this.bookingContact.chineseLastName
      params.pyFirstName = this.bookingContact.pinyinFirstName
      params.pyLastName = this.bookingContact.pinyinLastName
      this.$loading.show();
      const { success, errMsg } = await api.booking.addContactNew({
        bookingKey: this.bookingKey,
        smsKey: this.smsKey,
        viewModel: {
          ...params,
          userName: this.$store.state.user.userToken,
          smsCode: this.smsCode,
        },
      });
      this.$loading.hide();
      if (success) {
        await this.getContactList()
        await this.getGuestList()
        this.order.booking = this.updateBookings(this.order.bookings)
        this.selectedContact = this.bookingContact
        // await this.getBookings()
      } else {
        this.$alert.show(errMsg);
      }
    },
    //提交订单，提交前检查乘客是否重复
    async checkGuestRepeatSubmitBooking({marketingFlagChecked}) {
      const guestPass = this.passengerNonEmptyVerification();
      if (!guestPass) return;
      this.marketingFlagChecked = marketingFlagChecked
      if (this.allowUseTikTokCode) {
        let tikTokCouponCodeList = [];
        let isVerify = true;
        let verifyMsg = "";
        let tikTokCouponCodeListInvalid = [];
        for (let i = 0; i < this.bookings.length; i++) {
          let row = this.bookings[i];
          if (row.tikTokCouponCode) {
            if (row.tikTokCouponCodeErr !== "") {
              tikTokCouponCodeListInvalid.push(`【${row.tikTokCouponCode}】${row.tikTokCouponCodeErr}`);
            }
            tikTokCouponCodeList.push(row.tikTokCouponCode);
          } else {
            isVerify = false;
            verifyMsg = "请填写抖音团购核销码！";
            break;
          }
        }
        if (!isVerify) {
          this.$alert.show(verifyMsg);
          return;
        }

        tikTokCouponCodeList = [...new Set(tikTokCouponCodeList)];
        if (tikTokCouponCodeList.length < this.bookings.length) {
          isVerify = false;
          verifyMsg = "多间房需要输入不同的抖音核销码！";
          this.$alert.show(verifyMsg);
          return;
        }
      }

      this.$loading.show();
      let passCheckNum = 0;
      for (let i = 0; i < this.bookings.length; i++) {
        const result = await this.checkGuestRepeatHpApi(this.bookings[i]);
        //乘客信息有重复，直接提示，点击确定提交，取消不进行操作
        if (result.success && result.data.isAlert) {
          this.$confirm.show(result.data.alertMsg, {
            confirmBtn: '确定',
            cancelBtn: '取消',
            confirmCallBack: async () => {
              await this.submitBooking();
            }
          })
          break;
        } else {
          passCheckNum++
        }
      }

      //检查通过数和订单数量一致，所有订单通过检查，直接提交
      if (passCheckNum === this.bookings.length) {
        await this.submitBooking();
      }
    },
    //客户重复检查接口调用
    async checkGuestRepeatHpApi(booking) {
      const requestData = {
        bookingKey: this.bookingKey,
        token: booking.sessionToken,
        userName: this.$store.state.user.userToken
      };
      const result = await api.booking.checkGuestRepeatHp(requestData);
      this.$loading.hide();
      return {
        success: result.success,
        errMsg: result.errMsg,
        data: result.data
      };
    },
    async submitBooking() {
      if (!this.checkBookingContact(true)) {
        return;
      }
      try {
        if (window.gio) {
          const hmsr = this.$store.state.page.trackingCode.hmsr || "";
          if (hmsr.length > 0) {
            window.gio("track", "BF03_OrderGenerationPage");
          }
          if (this.bookings.some((r) => r.isnrp)) {
            window.gio("track", "NRP_BF03");
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.$loading.show();
      if(this.bookingContact.name) delete this.bookingContact.name
      const { success, errMsg } = await api.booking.addBookingCotact({
        bookingKey: this.bookingKey,
        smsKey: this.smsKey,
        viewModel: {
          ...this.bookingContact,
          lastName: this.bookingContact.chineseLastName || '',
          firstName: this.bookingContact.chineseFirstName || '',
          pyLastName: this.bookingContact.pinyinLastName || '',
          pyFirstName: this.bookingContact.pinyinFirstName || '',
          userName: this.$store.state.user.userToken,
          smsCode: this.smsCode,
        },
      });
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        return;
      }
      let checkGuestInfo = await this.checkSubmitData();
      if (!checkGuestInfo) return;
      let results = [];
      for (let i = 0; i < this.bookings.length; i++) {
        const reuslt = await this.submitBookingApi(this.bookings[i]);
        results.push(reuslt);
      }
      this.submitBookingResultHandler(results);
    },
    async checkSubmitData() {
      this.$loading.show();
      const requestData = {
        bookingKey: this.bookingKey,
      };
      const { success, errMsg } = await api.booking.checkGuestHP(requestData);
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
      }

      return success;
    },
    async submitBookingApi(booking) {
      this.$loading.show();
      const requestData = {
        bookingKey: this.bookingKey,
        shorexId: this.shorex.id,
        token: booking.sessionToken,
        couponCode: booking.couponCode,
        publicCouponCode: booking.publicCouponCode,
        source: "mobile",
        auth: true,
        tikTokCampaignCode: this.allowUseTikTokCode ? booking.tikTokCampaignCode : '',
        tikTokCouponCode: this.allowUseTikTokCode ? booking.tikTokCouponCode : '',
        marketingFlag: this.marketingFlagChecked
      };
      const result = await api.booking.submitBooking(requestData);
      this.$loading.hide();
      return {
        success: result.success,
        booking: booking,
        showAlert: true,
        errMsg: result.errMsg,
        data: result.data,
      };
    },
    // 预订提交后的处理
    // 如果全部失败，alert提示
    // 如果部分失败，confirm提示，并刷新页面
    // 如果全部成功，进入支付页面
    submitBookingResultHandler(results) {
      if (results.length == 0) {
        return;
      }
      this.$store.dispatch("GET_SHOPPING_CART_COUNT");
      const failureResults = results.filter((r) => !r.success);
      const successResults = results.filter((r) => r.success);
      if (failureResults.length == 0) {
        if (this.allowUseTikTokCode) {
          // 抖音核销订单进入订单列表
          this.$router.push({
            name: "BookingList"
          });
        } else {
          // 全部成功，进入支付页面
          this.$router.push({
            name: "Pay",
            query: {
              shipCode: this.shipCode,
              sailDate: this.sailDate,
              orderId: successResults[0].data,
            },
          });
        }
      } else {
        const self = this;
        let stateroomInfo = [];
        failureResults.forEach((result) => {
          if (result.booking) {
            stateroomInfo.push(result.errMsg);
          }
        });
        const stateroomText = stateroomInfo.join("，");
        if (failureResults.length < results.length) {
          // 如果部分失败，confirm提示，并刷新页面
          const text = `您选择的&nbsp;<span class="failureRoomTxt">${stateroomText}</span> 您可以继续为已创建的订单付款。`;
          self.$confirm.show(text, {
            confirmCallBack: () => {
              self.$router.push({
                name: "Pay",
                query: {
                  shipCode: self.shipCode,
                  sailDate: self.sailDate,
                  orderId: successResults[0].data,
                },
              });
            },
            cancelCallBack: () => {
              location.reload();
            },
            confirmBtn: "去支付",
          });
        } else {
          // 如果全部失败，alert提示
          const text = `您选择的&nbsp;<span class="failureRoomTxt">${stateroomText}</span>`;
          self.$alert.show(text, {
            confirmCallBack: () => {
              location.reload();
            },
          });
        }
      }
    },
    checkBookingContact(isShowAlert) {
      console.log('this.bookingContact', this.bookingContact)
      let isCN = this.getCountryArea(this.bookingContact.country)
      if (isCN) {
        if (!this.bookingContact.chineseFirstName || this.bookingContact.chineseFirstName.trim() == "") {
          if (isShowAlert) {
            this.$alert.show("请输入联系人名字");
          }
          return false;
        }
        if (!this.bookingContact.chineseLastName || this.bookingContact.chineseLastName.trim() == "") {
          if (isShowAlert) {
            this.$alert.show("请输入联系人姓");
          }
        }
      }
      console.log('this.bookingContact.country', this.bookingContact.country)
      if (!this.bookingContact.telephone || this.bookingContact.telephone.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入联系人手机号");
        }
        return false;
      }
      if (!this.bookingContact.email || this.bookingContact.email.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入联系人邮箱");
        }
        return false;
      }

      if (!checkTel(this.bookingContact.telephone) && this.bookingContact.callingCode && this.bookingContact.callingCode.indexOf('86') >= 0) {
        this.$alert.show('请输入正确的手机号')
        return false
      }

      if (!checkMail(this.bookingContact.email)) {
        this.$alert.show('请输入正确的邮箱')
        return false
      }
      return true;
    },
    saveBookingContact(isShowAlert) {
      if (!this.bookingContact.chineseLastName || this.bookingContact.chineseLastName.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入中文姓");
        }
        return false;
      }
      if (!this.bookingContact.chineseFirstName || this.bookingContact.chineseFirstName.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入中文名");
        }
        return false;
      }
      if (!this.bookingContact.pinyinLastName || this.bookingContact.pinyinLastName.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入拼音姓");
        }
        return false;
      }
      if (!this.bookingContact.pinyinFirstName || this.bookingContact.pinyinFirstName.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入拼音名");
        }
        return false;
      }
      if (!this.bookingContact.telephone || this.bookingContact.telephone.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入联系人手机号");
        }
        return false;
      }
      if (!this.bookingContact.email || this.bookingContact.email.trim() == "") {
        if (isShowAlert) {
          this.$alert.show("请输入联系人邮箱");
        }
        return false;
      }

      if (!checkTel(this.bookingContact.telephone) && this.bookingContact.callingCode && this.bookingContact.callingCode.indexOf('86') >= 0) {
        this.$alert.show('请输入正确的手机号')
        return false
      }

      if (!checkMail(this.bookingContact.email)) {
        this.$alert.show('请输入正确的邮箱')
        return false
      }
      return true;
    },
    getCountryName(countryCode) {
      const country = this.countries.filter(r => r.countryCode == countryCode || r.countryName == countryCode)
      if (country.length == 0) {
        return ""
      }
      return country[0].countryName
    },
    // 获取舱房对象
    getStateroom(booking) {
      if (!booking.stateroomPartRecord) {
        return {};
      }
      return booking.stateroomPartRecord;
    },
    // 舱房名称
    getStateroomName(booking) {
      const stateroom = this.getStateroom(booking);
      let name = stateroom.cnName + "";
      const shelter = stateroom.stateroomShelter;
      if (shelter && shelter.length > 0 && name.indexOf("遮挡") < 0) {
        name += "（有遮挡）";
      }
      let code = stateroom.stateroomCategoryCode;
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      let guestNumberText = "";
      switch (booking.guestNumber) {
        case 1:
          guestNumberText = "单人房";
          break;
        case 2:
          guestNumberText = "双人房";
          break;
        case 3:
          guestNumberText = "三人房";
          break;
        case 4:
          guestNumberText = "四人房";
          break;
        default:
          break;
      }
      return `${name}_${code}（${guestNumberText}）`;
    },
    // 阳台面积，包含遮挡率
    getBalconyArea(booking) {
      const stateroom = this.getStateroom(booking);
      if (
        !stateroom.balconyAreaInfo ||
        stateroom.balconyAreaInfo == "" ||
        stateroom.balconyAreaInfo == "无"
      ) {
        return "无阳台";
      }
      if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
        return (
          "(" +
          stateroom.stateroomShelter +
          "视线遮挡) " +
          stateroom.balconyAreaInfo
        );
      }
      return stateroom.balconyAreaInfo;
    },
    // 获取乘客
    getGuests(booking) {
      let guests = [];
      for (let i = 0; i < booking.guestNumber; i++) {
        guests.push("");
      }
      if (
        !booking.guests ||
        !booking.guests.guestPersons ||
        booking.guests.guestPersons.length == 0
      ) {
        return guests;
      }
      for (let i = 0; i < booking.guests.guestPersons.length; i++) {
        if (i < guests.length) {
          const guest = booking.guests.guestPersons[i];
          let name = guest.lastName + guest.firstName;
          if (!name || name.trim().length == 0) {
            name = `${guest.pyLastName} ${guest.pyFirstName}`;
          }
          guests[i] = name;
        }
      }
      return guests;
    },
    // 优惠券自动选择
    async couponAutoSelect() {
      if (!this.coupons || this.coupons.length == 0) {
        return;
      }
      for (let i = 0; i < this.bookings.length; i++) {
        let booking = this.bookings[i];
        if (booking.couponCode && booking.couponCode.length > 0) {
          continue;
        }
        for (let j = 0; j < this.coupons.length; j++) {
          const coupon = this.coupons[j];
          // 跳过会员专属优惠券和OPBK优惠
          if (coupon.isMemberSelfUse || coupon.isSelfUse) continue;
          if (await this.addCouponCode(booking, coupon.token, coupon, false)) {
            break;
          }
        }
      }
    },
    // 检查优惠券是否可以选择
    checkCouponCanUse(booking, coupon, isShowAlert) {
      // 先检查优惠券是否被其他订单使用了
      if (
        this.bookings.some(
          (r) =>
            r.sessionToken != booking.sessionToken &&
            r.couponCode == coupon.token
        )
      ) {
        if (isShowAlert) {
          this.$alert.show("该优惠券已被选中，请更换优惠券");
        }
        return false;
      }
      // 检查是否满足舱房，人数和航线要求
      const cruiseCode = this.getCruiseCode(booking);
      if (cruiseCode == "") {
        return false;
      }
      if (!coupon.cruiseCodes || coupon.cruiseCodes.indexOf(cruiseCode) < 0) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }
      const stateroomCode = booking.shipCode + booking.berthedCategoryCode;
      if (
        !coupon.stateroomCodes ||
        coupon.stateroomCodes.indexOf(stateroomCode) < 0
      ) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }
      if (
        !coupon.guestNumber ||
        coupon.guestNumber.indexOf(booking.guestNumber + "") < 0
      ) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }

      return true;
    },
    // 添加优惠券接口
    async addCouponCode(booking, couponCode, coupon, isShowAlert) {
      if (
        couponCode &&
        couponCode.length > 0 &&
        !this.checkCouponCanUse(booking, coupon, isShowAlert)
      ) {
        return false;
      }
      const requestData = {
        token: booking.sessionToken,
        couponCode: couponCode,
        publicCouponCode: booking.publicCouponCode,
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        stateroomCategoryCode: booking.berthedCategoryCode,
        guestNumber: booking.guestNumber,
        bookingKey: this.bookingKey,
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.updateCouponCode(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        return false;
      }
      booking.couponCode = couponCode;
      if (data && data.model && data.model.bookings) {
        let order = this.order;
        order.bookings = data.model.bookings;
        let integrals = 0
        order.bookings.forEach(booking => {
          if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
            booking.bookingIntegrals.forEach(item => {
              integrals += Number(item.integral)
            })
          }
        })
        this.getBookingsGuests(order.bookings)
        order.bookings = this.updateBookings(order.bookings)
        this.bookingIntegrals = integrals
        this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
      }
      return true;
    },
    // 输入活动码
    async addPublicCouponCode(e, sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      const booking = bookings[0];
      let value = e.target.value;
      const requestData = {
        token: booking.sessionToken,
        couponCode: booking.couponCode,
        publicCouponCode: value,
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        stateroomCategoryCode: booking.berthedCategoryCode,
        guestNumber: booking.guestNumber,
        bookingKey: this.bookingKey,
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.updateCouponCode(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        return false;
      }
      booking.publicCouponCode = value;
      if (data && data.model && data.model.bookings) {
        let order = this.order;
        order.bookings = data.model.bookings;
        let integrals = 0
        order.bookings.forEach(booking => {
          if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
            booking.bookingIntegrals.forEach(item => {
              integrals += Number(item.integral)
            })
          }
        })
        this.getBookingsGuests(order.bookings)
        order.bookings = this.updateBookings(order.bookings)
        this.bookingIntegrals = integrals
        this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
      }
      return true;
    },
    // 优惠券选择后的处理
    async onCouponCodeSelected(e, sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      let value = e.target.value;
      let result = true;
      if (value == "") {
        result = await this.addCouponCode(bookings[0], value, true);
      } else {
        const coupon = this.coupons.filter((r) => r.token == value);
        if (coupon.length == 0) {
          return;
        }
        result = await this.addCouponCode(bookings[0], value, coupon[0], true);
      }
      // 如果优惠券不满足条件，设置回之前选择的券
      if (!result) {
        e.target.value = "";
      }
    },
    // 获取SC20210511格式code
    getCruiseCode(booking) {
      const sailDate = booking.sailDate;
      if (sailDate && booking.sailDate.length >= 10) {
        let lists = sailDate.split("-");
        return booking.shipCode + lists[0] + lists[1] + lists[2];
      }
      return "";
    },
    // 展示联系人列表
    // contactModel = contact / guest
    // sessionToken，booking对象的sessionToken，标记不同的订单
    showContactList(contactMode, sessionToken) {
      this.contactMode = contactMode;
      // 根据contact mode读取数据
      if (contactMode == "contact") {
        // 读取联系人信息
        this.maxGuestCount = 1;
        this.guestInfoDesc = "";
        if (this.bookingContact) {
          this.selectContactIds = [this.bookingContact.id];
        } else {
          this.selectContactIds = [];
        }
      } else {
        this.guestInfoDesc = "同一航次，同一乘客不可重复添加";
        // 根据sessionToken查询booking，读取里面的guest信息
        const bookings = this.bookings.filter(
          (r) => r.sessionToken == sessionToken
        );
        if (bookings.length == 0) return;
        this.targetBooking = bookings[0];
        const booking = bookings[0];
        this.maxGuestCount = booking.guestNumber;
        if (!booking.guests || !booking.guests.guestPersons) {
          this.selectContactIds = [];
        } else {
          this.selectContactIds = booking.guests.guestPersons.map((r) => r.id);
        }
      }
      this.isShowContactList = true;
      this.showPopup();
    },
    // 确认订单联系人
    async onBookingContactConfirm(contact, type) {
      if (!this.checkContact(contact)) return;
      let name = contact.chineseLastName + contact.chineseFirstName;
      if (!name || name.trim().length == 0) {
        name = `${contact.pinyinLastName} ${contact.pinyinFirstName}`;
      }
      if(type==='confirmContact') await this.getContactList(type);
      this.bookingContact = {
        ...contact,
        // name,
      };
      this.contactsList && this.contactsList.forEach((item, idx) => {
        if (item.id === contact.id) {
          this.selectedGuestIdx = idx;
          this.selectedContact = item;
        }
      })
      this.closeContactList();
      if (!this.bookingKey || this.bookingKey.length == 0) {
        return;
      }
      this.$loading.show();
      await api.booking.addBookingCotact({
        bookingKey: this.bookingKey,
        smsKey: this.smsKey,
        viewModel: {
          ...this.bookingContact,
          userName: this.$store.state.user.userToken,
          smsCode: this.smsCode,
        },
      });
      this.$loading.hide();
    },
    // 选择乘客
    onGuestContactConfirm(guestsList) {
      guestsList.forEach(i => {
        console.log(i)
        i.isCommonUseContact = true
      })
      const guests = this.getGuestsByContacts(guestsList);
      if (!guests || guests.length == 0) return;
      if (!this.checkGuest(guests)) return;
      this.addGuestsApi(guests);
    },
    async addGuestsApi(guests) {
      const pattern = new RegExp("[\u4E00-\u9FA5]+");
      guests.forEach((guest) => {
        if (pattern.test(guest.nationality)) {
          // 中文字符，转成code
          const country = this.countries.find(
            (r) => r.countryName == guest.nationality
          );
          if (
            !country ||
            !country.countryCode ||
            country.countryCode.length == 0
          ) {
            guest.nationality = "CN";
          } else {
            guest.nationality = country.countryCode;
          }
        }
      });
      const requestData = {
        bookingKey: this.bookingKey,
        token: this.targetBooking.sessionToken,
        guests: {
          guestPersons: guests,
        },
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.addBookingGuests(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        let order = this.order;
        order.bookings && order.bookings.forEach(booking => {
          if (booking.sessionToken === this.targetBooking.sessionToken) {
            booking.guestsList && booking.guestsList.forEach(guest => {
              guest.isActive = false
              order.bookings = this.updateBookings(order.bookings)
              this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
            })
          }
        })
        this.$alert.show(errMsg);
        return;
      }
      if (data && data.model && data.model.bookings) {
        let order = this.order;
        let bookingsOriginal = this.bookingsOriginal = [...order.bookings];
        let guestPersonsNew = []
        this.targetBooking.guestPersons.forEach(guest => {
          let isCN = this.getCountryArea(guest.country)
          if (isCN) {
            if (!isEmpty(guest.chineseFirstName) || !isEmpty(guest.chineseLastName) || !isEmpty(guest.pinyinFirstName) || !isEmpty(guest.pinyinLastName)) {
              guestPersonsNew.push(guest)
            } else {
              guestPersonsNew.push(null)
            }
          } else {
            if (!isEmpty(guest.pinyinFirstName) || !isEmpty(guest.pinyinLastName)) {
              guestPersonsNew.push(guest)
            } else {
              guestPersonsNew.push(null)
            }
          }
        })
        let guestPersonsData = []
        // 添加乘客后激活乘客状态
        data.model.bookings.forEach(booking => {
          if (booking.sessionToken === this.targetBooking.sessionToken) {
            guestPersonsData = [...booking.guests.guestPersons]
          }
        });
        let ids = guestPersonsData.map(r => { return r.id })
        this.targetBooking.guestsList && this.targetBooking.guestsList.forEach(g => {
          g.isActive = ids.includes(g.id)
        })
        let guestPersonsFill = this.fillList(guestPersonsNew, guestPersonsData)
        guestPersonsFill && guestPersonsFill.forEach(item => {
          if (item) {
            item.chineseFirstName = item.chineseFirstName || item.firstName
            item.chineseLastName = item.chineseLastName || item.lastName
            item.pinyinFirstName = item.pinyinFirstName || item.firstName
            item.pinyinLastName = item.pinyinLastName || item.lastName
          }
        })
        order.bookings = data.model.bookings
        let integrals = 0
        if (data && data.model && data.model.bookings) {
          let order = this.order;
          this.bookingsOriginal = [...order.bookings];
          order.bookings = data.model.bookings
          this.guestsList = this.targetBooking.guestsList
          order.bookings.forEach(booking => {
            if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
              booking.bookingIntegrals.forEach(item => {
                integrals += Number(item.integral)
              })
            }
            if (this.targetBooking.sessionToken === booking.sessionToken) {
              booking.guestPersons = guestPersonsFill
              booking.guestsList = this.targetBooking.guestsList
            } else {
              booking.guestsList = this.guestsList
            }
            // 处理PCPGIFT价格
            bookingsOriginal && bookingsOriginal.forEach((oldRow)=> {
              if(booking.groupType === 'PCPGIFT' && oldRow.pcpGiftInfo){
                booking.pcpGiftInfo = oldRow.pcpGiftInfo
              }
            })
          })
          // 更新订单的guestList列表
          order.bookings = this.updateBookings(order.bookings)
          this.bookingIntegrals = integrals
          this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
        }
        this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
        this.getBookingsGuests(data.model.bookings)
      }
      this.closeContactList();
    },
    fillList(oldList, list) {
      let listIndex = 0;
      return oldList.map(item => {
        if (item === null) {
          if (listIndex < list.length) {
            return list[listIndex++]
          } else {
            return null;
          }
        } else {
          return item;
        }
      });
    },
    // 检查乘客信息
    checkGuest(guests, index = null) {
      if (!guests || guests.length == 0) return false;
      const self = this;
      for (let i = 0; i < guests.length; i++) {
        if (index !== null && i !== index) continue;
        const guest = guests[i];
        if (guest.nationality == "CN") {
          if (
            !guest.lastName ||
            guest.lastName.length == 0 ||
            !isChinese(guest.lastName)
          ) {
            self.$alert.show(`请正确填写${guest.name}的中文姓`);
            return false;
          }
          if (
            !guest.firstName ||
            guest.firstName.length == 0 ||
            !isChinese(guest.firstName)
          ) {
            self.$alert.show(`请正确填写乘客${guest.name}的中文名`);
            return false;
          }
          if (
            guest.passport &&
            guest.passport.length > 0 &&
            !checkPassport(guest.passport)
          ) {
            self.$alert.show(`请正确填写乘客${guest.name}的护照号`);
            return false;
          }
        }
        if (guest.lastName) {
            if(!isChinese(guest.lastName)){
              self.$alert.show(`请正确填写${guest.name}的中文姓`);
              return false;
            }
            if(!guest.firstName){
              self.$alert.show(`请正确填写乘客${guest.name}的中文名`);
              return false;
            }
        }
        if (guest.firstName) {
            if(!isChinese(guest.firstName)){
              self.$alert.show(`请正确填写乘客${guest.name}的中文名`);
              return false;
            }
            if(!guest.lastName){
              self.$alert.show(`请正确填写${guest.name}的中文姓`);
              return false;
            }
        }
        if (
          !guest.pyLastName ||
          guest.pyLastName.length == 0 ||
          !isLetter(guest.pyLastName)
        ) {
          self.$alert.show(`请正确填写乘客${guest.name}的姓拼音`);
          return false;
        }
        if (
          !guest.pyFirstName ||
          guest.pyFirstName.length == 0 ||
          !isLetter(guest.pyFirstName)
        ) {
          self.$alert.show(`请正确填写乘客${guest.name}的名拼音`);
          return false;
        }
        if (!guest.gender || guest.gender.length == 0) {
          self.$alert.show(`请选择乘客${guest.name}性别`);
          return false;
        }
        if (!guest.birthDate || guest.birthDate.length == 0) {
          self.$alert.show(`请选择乘客${guest.name}出生日期`);
          return false;
        }
        if (
          guest.telephone &&
          guest.telephone.length > 0 &&
          !checkTel(guest.telephone) && guest.callingCode && guest.callingCode.indexOf('86') >= 0
        ) {
          self.$alert.show(`请正确填写乘客${guest.name}的手机号`);
          return false;
        }
        if (guest.email && guest.email.length > 0 && !checkMail(guest.email)) {
          self.$alert.show(`请正确填写乘客${guest.name}的邮箱`);
          return false;
        }
      }
      return true;
    },
    // 检查乘客信息
    checkContact(contact) {
      const self = this;
      if (!contact) return false;
      let name = contact.chineseLastName + contact.chineseFirstName;
      if (!name || name.trim().length == 0) {
        name = `${contact.pinyinLastName} ${contact.pinyinFirstName}`;
      }
      if(isEmpty(contact.telephone)) {
        self.$alert.show(`请输入乘客${name}的手机号`);
        return false;
      } else {
        if (
            contact.telephone &&
            contact.telephone.length > 0 &&
            !checkTel(contact.telephone) && contact.callingCode && contact.callingCode.indexOf('86') >= 0
        ) {
          self.$alert.show(`请正确填写乘客${name}的手机号`);
          return false;
        }
      }

      if(isEmpty(contact.email)) {
        self.$alert.show(`请输入乘客${name}的邮箱`);
        return false;
      } else {
        if (contact.email && contact.email.length > 0 && !checkMail(contact.email)) {
          self.$alert.show(`请正确填写乘客${name}的邮箱`);
          return false;
        }
      }
      return true;
    },
    // 将常用联系人转换成乘客对象
    getGuestsByContacts(guestsList) {
      let guests = [];
      guestsList.forEach((contact) => {
        let name = contact.chineseLastName + contact.chineseFirstName;
        if (!name || name.trim().length == 0) {
          name = `${contact.pinyinLastName} ${contact.pinyinFirstName}`;
        }
        guests.push({
          nationality: contact.country,
          lastName: contact.chineseLastName,
          firstName: contact.chineseFirstName,
          pyLastName: contact.pinyinLastName,
          pyFirstName: contact.pinyinFirstName,
          name: name,
          birthDate: contact.dateOfBirth,
          passport: contact.passportNum,
          passportExpiresIn: contact.passportExpirationDate,
          gender: contact.gender || "M",
          telephone: contact.telephone,
          email: contact.email,
          id: contact.id,
          isActive: true,
          isCommonUseContact: contact.isCommonUseContact
        });
      });
      return guests;
    },
    closeContactList() {
      this.isShowContactList = false;
    },
    closeChangeStateroom() {
      this.isShowChangeStateroom = false;
    },
    // 点击更换房间号，call接口获取其他可用的房间号
    async onChangeStateroomClick(sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      const booking = bookings[0];
      this.targetBooking = booking;
      // 获取可用的房间号
      let guestAges = [];
      for (let i = 0; i < booking.guestNumber; i++) {
        guestAges.push(30);
      }
      const requestData = {
        shipCode: booking.shipCode,
        sailDate: booking.sailDate,
        packageId: booking.packageId,
        fareCode: booking.fareCode,
        stateroomCategoryCode: booking.berthedCategoryCode,
        currency: "CNY",
        guestAges: guestAges,
        agencyId: booking.agencyId,
        groupAgencyId: booking.groupAgencyId,
        groupId: booking.groupId,
        groupType: booking.groupType,
        agencyName: booking.agencyName,
        requestSequence: booking.requestSequence,
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.getCabins(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
      }
      this.targetCabins = data;
      this.isShowChangeStateroom = true;
    },
    // 确认更换房间号
    async onChangeStateroomConfirm(sessionToken, cabinNumber, deckNumber) {
      let bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) {
        this.closeChangeStateroom();
        return;
      }
      let booking = bookings[0];
      // 如果房间号没有变化，不需要提交
      if (booking.stateroomNumber == cabinNumber) {
        this.closeChangeStateroom();
        return;
      }
      const requestData = {
        bookingKey: this.bookingKey,
        token: sessionToken,
        stateroomCategoryCode: booking.berthedCategoryCode,
        stateroomNumber: cabinNumber,
        deckNumber,
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.changeStateroomNumber(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        return;
      }
      booking.deckNumber = deckNumber;
      booking.stateroomNumber = cabinNumber;
      booking.stateroomShelter = data.stateroomShelter;
      booking.stateroomNumberRemark = data.stateroomNumberRemark;
      this.$store.commit("SET_BOOKING_FUNNEL_ORDER", this.order);
      this.closeChangeStateroom();
    },
    // 连通房展示甲板图
    showBookingDeck(sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      const booking = bookings[0];
      this.targetBooking = booking;
      this.isShowBookingDeck = true;
    },
    closeBookingDeckPopup() {
      this.isShowBookingDeck = false;
    },
    // 展示新建/编辑联系人，为了配合window popstate用
    showContactEdit() {
      this.isShowContactEdit = true;
      this.showPopup();
    },
    // 关闭新建/编辑联系人，为了配合window popstate用
    closeContactEdit() {
      this.isShowContactEdit = false;
    },
    showPopup() {
      history.pushState({ page: "guestInfo" }, null);
    },
    // 获取图形验证码
    async getPicCode() {
      const { success, data, errMsg } = await api.user.picCode(this.smsKey);
      if (!success) console.error(errMsg);
      if (data) {
        this.picCodeImage = "data:image/png;base64," + data.imageBase64;
        this.$store.dispatch("SET_SESSION_KEY", data.sessionKey);
      }
    },
    callingCodeChanged(event) {
      let code = event.target.value + "";
      if (code && code.length > 0) {
        this.bookingContact.callingCode = code.replace("+", "");
      }
    },
    // 获取短信验证码
    async sendSmsCode(codeType, codeValue) {
      
      
      let callingCode = this.bookingContact.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }
      const { success, errMsg } = await api.user.SendSmsCodeWithPicCodeV3({
        phone: this.bookingContact.telephone,
        picCode: this.picCode,
        callingCode: callingCode,
        sessionKey: this.smsKey,
        codeType:codeType,
        captchaVerifyParam: codeValue,
        sceneId:SCENE_ID
      });
      this.$loading.hide();
      this.getPicCode();
      if (!success) {
        this.$alert.show(errMsg);
        return;
      } else {
        this.$alert.show(
          "短信发送成功！若您没有收到短信验证，请一分钟后重新发送。"
        );
      }
      this.smsCodeCountDown = 60;
      const self = this;
      let countDown = setInterval(() => {
        if (self.smsCodeCountDown == 0) {
          clearInterval(countDown);
        } else {
          self.smsCodeCountDown--;
        }
      }, 1000);
    },
    // 客房详情
    showStateroomDetailPopup(booking) {
      let bookingDetail = null;
      this.bookingsOriginal.forEach(r => {
        if (r.sessionToken === booking.sessionToken) {
          bookingDetail = r;
        }
      });
      if (booking.stateroomPartRecord) {
        this.selectStateroom = {
          stateroomImages: booking.stateroomImages,
          stateroomName: booking.stateroomPartRecord.cnName,
          stateroomCategory: booking.berthedCategoryCode,
          stateroomPriceType: this.getNrpPriceType(booking),
          stateroomPrice: booking.netAmount / booking.guestNumber,
          stateroomCapacity: booking.stateroomPartRecord.capacity,
          stateroomArea: booking.stateroomPartRecord.areaInfo,
          stateroomBalcony: booking.stateroomPartRecord.balconyAreaInfo,
          stateroomFloor: "",
          isQiaohu: booking.groupType == "QIAOHU",
          isStarrySky: booking.groupType == "STARRYSKY",
          stateroomDescription: booking.stateroomPartRecord.description,
          stateroomNrpTitle: this.getNrpTitle(booking),
          stateroomNrpText: this.getNrpDecription(booking),
          suiteMobileImageUrl: booking.stateroomPartRecord.suiteMobileImageUrl,
          stateroomShelter: booking.stateroomShelter,
          deviceFeatureTags: bookingDetail.featureDeviceTags,
          deviceGroupTags: bookingDetail.deviceTags
        };
        this.isShowStateroomDetailPopup = true;
        this.showPopup();
      }
    },
    closeStateroomDetailPopup() {
      this.selectStateroom = {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        isStarrySky: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        stateroomShelter: "",
        deviceFeatureTags: [],
        deviceGroupTags: []
      };
      this.isShowStateroomDetailPopup = false;
    },
    getNrpTitle(booking) {
      if (this.isFortyEightHoursNrpCruise)
        return nrpConfig.fortyEightHoursNrp.title;
      return booking.isnrp ? nrpConfig.nrp.title : nrpConfig.rp.title;
    },
    getNrpPriceType(booking) {
      if (this.isFortyEightHoursNrpCruise)
        return nrpConfig.fortyEightHoursNrp.priceType;
      return booking.isnrp ? nrpConfig.nrp.priceType : nrpConfig.rp.priceType;
    },
    getNrpDecription(booking) {
      if (this.isFortyEightHoursNrpCruise)
        return nrpConfig.fortyEightHoursNrp.description;
      // return booking.isnrp
      //   ? nrpConfig.nrp.description
      //   : nrpConfig.rp.description;
      if(booking.isnrp){
        // 收费退订
        if(this.order.bookingIndex && this.order.bookingIndex.isRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
      }else{
        // 常规退订
                if(this.order.bookingIndex && this.order.bookingIndex.isRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicy
                }
      }
    },
    // 常规/收费退订弹窗
    showNrpPopup(booking) {
      this.targetBooking = booking;
      this.isShowNrpPopup = true;
      this.showPopup();
    },
    closeNrpPopup() {
      this.targetBooking = {};
      this.isShowNrpPopup = false;
    },
    showBankPopup() {
      this.isShowBankPopup = true;
      this.showPopup();
    },
    closeBankPopup() {
      this.isShowBankPopup = false;
    },
    showPrivacy(tab) {
      this.privacyTab = tab;
      this.isShowPrivacy = true;
      this.changePrivacyTab(tab);
      this.showPopup();
    },
    closePrivacy() {
      this.isShowPrivacy = false;
    },
    showQiaohuPopup() {
      this.isShowQiaohuPopup = true;
      this.showPopup();
    },
    closeQiaohuPopup() {
      this.isShowQiaohuPopup = false;
    },
    closeStarrySkyPopup() {
      this.isShowStarrySkyPopup = false;
    },
    openCustomThemePopup(val) {
      this.personalizedStateroomInfo = val;
      this.isShowCustomThemePopup = true;
    },
    closeCustomThemePopup() {
      this.isShowCustomThemePopup = false;
    },
    showConnectRoomPopup() {
      this.isShowConnectRoomPopup = true;
      this.showPopup();
    },
    closeConnectRoomPopup() {
      this.isShowConnectRoomPopup = false;
    },
    changePrivacyTab(tab) {
      if (this.tabHistory.indexOf(tab) < 0) {
        this.tabHistory.push(tab);
      }
    },
    changeCouponShow(index) {
      if (index < 0 || index > 3) return;
      this.$set(this.isCouponShow, index, !this.isCouponShow[index]);
    },
    goBackShoppingCart() {
      const query = this.$router.currentRoute.query;
      if (query.shipCode && query.sailDate) {
        this.$router.push({
          name: "CruiseDetail",
          query: {
            shipCode: query.shipCode,
            sailDate: query.sailDate,
          },
        });
      } else {
        this.$router.push({ name: "ShoppingCart" });
      }
    },
    setCountDownText() {
      const self = this;
      const endDate = new Date(this.countDown).getTime();
      const curDate = new Date().getTime();
      const totalSeconds = parseInt((endDate - curDate) / 1000);
      if (totalSeconds >= 0) {
        const minute = this.fixedTime(Math.floor((totalSeconds / 60) % 60));
        const second = this.fixedTime(Math.floor(totalSeconds % 60));
        self.countDownText = `${minute}:${second}`;
        this.countDownTimeout = setTimeout(() => {
          self.setCountDownText();
        }, 1000);
      } else {
        if (this.$router.currentRoute.name != "GuestInfo") return;
        this.$confirm.show("房间预订超时,是否续订房间", {
          confirmCallBack: () => {
            self.refreshLockStateroom();
          },
          cancelCallBack: () => {
            self.goBackShoppingCart();
          },
        });
      }
    },
    fixedTime(time) {
      if (time < 10) {
        return "0" + time;
      }
      return time + "";
    },
    async refreshLockStateroom() {
      this.$loading.show();
      const result = await api.booking.refreshLockStateroom({
        bookingKey: this.bookingKey,
      });
      this.$loading.hide();
      if (!result.success) {
        this.goBackShoppingCart();
        return;
      }
      await this.getBookings();
      this.$store.commit("SET_PAGE_REFRESH", new Date().getTime().toString());
    },
    closePromptPopups() {
      this.$router.go(-1);
    },
    async headCallPrompt() {
      this.isShowPromptPopups = false
      this.$loading.show();
      const couponResult = await api.user.getAvailableCoupons(this.$store.state.user.userToken);
      this.$loading.hide();
      if (couponResult.success) {
        this.coupons = couponResult.data;
        await this.couponAutoSelect();
      }
    },
    // 点击完善信息
    editInfo() {
      if (process.browser) {
        window.location.href = `/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
          location.href
        )}`
      }
    },
    onConfirmSpecial(e) {
      let order = this.updateBookings(e)
      this.getBookingsGuests(e)
      this.$store.commit('SET_BOOKING_FUNNEL_ORDER', order)
    },
    getCountryArea(country) {
      return country === "CN" ||
        country === "HK" ||
        country === "MAC" ||
        country === "TWN";
    },
    // 提交前非空验证
    passengerNonEmptyVerification() {
      const isDomesticNationality = (nationality) => {
        if (!nationality) return true; // 默认或者未选时，按国内乘客验证（中文姓名必填）
        return (
            nationality === "CN" ||
            nationality === "HK" ||
            nationality === "MAC" ||
            nationality === "TWN"
        );
      };

      const isBlank = (v) => !v || (isEmpty(v));

      //验证乘客信息
      const isGuestValid = (guest) => {
        if (!guest) return false;
        const nationality = guest.country;
        const requiredKeys = isDomesticNationality(nationality)
            ? ["chineseLastName", "chineseFirstName", "pinyinLastName", "pinyinFirstName", "dateOfBirth", "gender"]
            : ["pinyinLastName", "pinyinFirstName", "dateOfBirth", "gender"];
        return requiredKeys.every((k) => !isBlank(guest[k]));
      };

      for (let i = 0; i < this.bookings.length; i++) {
        const row = this.bookings[i];
        const stateroomName = row && row.stateroomPartRecord ? this.getPassengerNonEmptyStateroomName(row.stateroomPartRecord) : "";
        const guests = row && row.guestPersons ? row.guestPersons : null;

        if (!guests || guests.length === 0) {
          this.$alert.show(`请填写 ${stateroomName} 的乘客信息`);
          return false;
        }

        // 验证每个订单中的每个乘客信息
        for (let g = 0; g < guests.length; g++) {
          if (!isGuestValid(guests[g])) {
            this.$alert.show(`请填写 ${stateroomName} 的乘客信息`);
            return false;
          }
        }
      }
      return true;
    },
    // 舱房名称
    getPassengerNonEmptyStateroomName(stateroom) {
      let name = stateroom.cnName + ''
      const shelter = stateroom.stateroomShelter
      if (shelter && shelter.length > 0 && name.indexOf('遮挡') < 0) {
        name += "（有遮挡）"
      }
      return `${name}`
    }
  },
  computed: {
    bookingKey() {
      return this.$store.state.booking.bookingKey;
    },
    order() {
      console.log(this.$store.state.booking.order,'this.$store.state.booking.order')
      return this.$store.state.booking.order;
    },
    bookings() {
      if (!this.order.bookings || this.order.bookings.length == 0) {
        return [];
      }
      return this.order.bookings;
    },
    shipCode() {
      if (!this.bookings || this.bookings.length == 0) {
        return "";
      }
      return this.bookings[0].shipCode;
    },
    sailDate() {
      if (!this.bookings || this.bookings.length == 0) {
        return "";
      }
      return this.bookings[0].sailDate;
    },
    contact() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return {};
      }
      return this.order.bookings[0].contact;
    },
    specialBookingInfoView() {
      return this.order.specialBookingInfoView || {};
    },
    needShowSmsCode() {
      const user = this.$store.state.user.userInfo;
      if (!user || !user.mobileH || user.mobileH == "") return true;
      return (
        !this.bookingContact ||
        !this.bookingContact.telephone ||
        this.bookingContact.telephone != user.mobileH
      );
    },
    selectedCallingCode() {
      let selectCallingCode = this.bookingContact.callingCode + "";
      if (
        !this.bookingContact.callingCode ||
        this.bookingContact.callingCode.length == 0
      ) {
        selectCallingCode = "86";
      }
      if (selectCallingCode.indexOf("+") < 0) {
        selectCallingCode = "+" + selectCallingCode;
      }
      return (
        this.smsCallingCodes.find((r) => r.callingCode == selectCallingCode) ||
        {}
      );
    },
    normalBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }

      return this.order.bookings.filter(
        (r) => {
          let currRow = this.bookingsOriginal && { ...this.bookingsOriginal.filter((oldRow) => oldRow.bookingAccessToken === r.bookingAccessToken)[0] }
          r.tikTokCampaignCode = sessionStorage.getItem("tikTokCode");
          r.tikTokCouponCode = currRow?.tikTokCouponCode || "";
          r.tikTokCouponCodeErr = "";
          return !r.connectId || r.connectId == ""
        }
      );
    },
    connectBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }
      return this.order.bookings.filter(
        (r) => {
          let currRow = this.bookingsOriginal && { ...this.bookingsOriginal.filter((oldRow) => oldRow.bookingAccessToken === r.bookingAccessToken)[0] }
          r.tikTokCampaignCode = sessionStorage.getItem("tikTokCode");
          r.tikTokCouponCode = currRow?.tikTokCouponCode || "";
          r.tikTokCouponCodeErr = "";
          return r.connectId && r.connectId.length > 0
        }
      );
    },
    is2021Sailing() {
      let sailDate = this.order.sailDate;
      if (!sailDate || sailDate.length < 10) return false;
      sailDate = sailDate.substring(0, 10);
      const time = new Date(sailDate);
      return time.getTime() >= new Date("2021-01-01").getTime();
    },
    isFortyEightHoursNrpCruise() {
      return this.order.isFortyEightHoursNrpCruise;
    },
    smsCallingCodes() {
      return this.$store.getters.smsCallingCodes;
    },
    smsKey() {
      return this.$store.state.page.sessionKey;
    },
    smsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
    shorex() {
      if (!this.order || !this.order.shorex) {
        return {};
      }
      return this.order.shorex;
    },
    payShorexCount() {
      if (!this.order) return 0;
      return this.order.payShorexCount || 0;
    },
    countries() {
      return this.$store.state.page.countries;
    },
    isLocalReward() {
      return (
        this.userDetail &&
        this.userDetail.memberLevelStr &&
        this.userDetail.memberLevelStr.length > 0
      );
    },
    isFinishSelfInfo() {
      let userInfo = this.$store.state.user.userInfo;
      let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
      return isLocalReward && userInfo.infoIntegrity === 100;
    },
    localRewardLink() {
      if (process.browser) {
        return `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
          location.href
        )}`;
      }
      return "";
    },
    completeInfoLink() {
      if (process.browser) {
        return `/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
          location.href
        )}`;
      }
      return "";
    },

  },
  watch: {
    // contact(newOne) {
    //   if (
    //     !this.bookingContact ||
    //     !this.bookingContact.name ||
    //     this.bookingContact.name == "" ||
    //     !this.bookingContact.telephone ||
    //     this.bookingContact.telephone == "" ||
    //     !this.bookingContact.email ||
    //     this.bookingContact.email == ""
    //   ) {
    //     this.bookingContact = {
    //       name: newOne.name,
    //       telephone: newOne.telephone,
    //       email: newOne.email,
    //       lastName: newOne.lastName,
    //       firstName: newOne.firstName,
    //       id: newOne.id,
    //       callingCode: newOne.callingCode,
    //       country: newOne.country || 'CN',
    //       nationality: newOne.nationality || 'CN',
    //     };
    //   }
    // },
    order(newOne) {
      newOne.bookings = this.updateBookings(newOne.bookings)
      this.$store.commit('SET_BOOKING_FUNNEL_ORDER', newOne);
    }
  },
};
</script>

<style lang="less" scoped>
input::-webkit-input-placeholder {
  color: #ccc;
}

.stateroomDetail-t {
  position: fixed;
  width: 100%;
  text-align: center;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  top: 0;
  left: 0;
  z-index: 5001;

  .stateroomDetail-returnButton {
    width: 30px;
    position: absolute;
    top: 4px;
    left: 20px;
    text-align: left;

    img {
      width: 33%;
    }
  }

  .stateroomDetail-t-title {
    
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    margin: 0;
  }
}

.list-block {
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 50px;
  &.bottom-deposit {
    padding-bottom: 82px;
  }
}

#guestInfoPage {
  .item-inner {
    padding: 9px 0 12px;

    .connectBooking-title {
      font-size: 14px;
      color: #9B9B9B;
      line-height: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 9px;

      .unsubscribePay {
        border: solid 1px #ED9100;
        font-weight: 400;
        font-size: 11px;
        color: #ED9100;
        margin-left: 5px;
      }

      img {
        width: 17px;
        height: 18px;
        margin-right: 3px;
      }
    }
  }

  .item-inner:after {
    height: 0px;
  }

  .countDownCon {
    padding: 5px 0;
    text-align: center;

    .countDownCon-txt {
      font-size: 10px;
      line-height: 14px;
      color: #999;
    }

    .countDownTime {
      color: #fc4141;
    }
  }

  .route-info {
    margin-bottom: 10px;
    padding: 15px 20px 14px 20px;
    background-color: #fff;

    .route-name {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      padding-bottom: 5px;
    }

    .route-name-icon {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      -moz-box-flex: 0;
      -ms-flex: none;
      flex: none;
      width: 17px;
      margin-right: 6px;
      padding-top: 3px;

      img {
        max-width: 100%;
      }
    }

    .route-name-txt {
      font-size: 14px;
      line-height: 20px;
      color: #333;
      font-weight: bold;
    }

    .route-ship {
      margin-left: 23px;
      padding-bottom: 6px;
      font-size: 12px;
      line-height: 16px;
      color: #666;
    }

    .route-row {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      margin-left: 23px;
      padding-bottom: 6px;

      .route-row-txt {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        font-size: 12px;
        line-height: 16px;
        color: #151515;
      }
    }
  }

  .cruiseInfo {
    background-color: #fff;
    padding: 0 20px;

    .guestsList-title {
      padding: 0;

      .item-inner {
        padding: 22px 0 14px 0;

        //border-bottom: 1px solid #d8d8d9;
        .item-title-row {
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;

          .item-contactTitel {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-weight: 400;
            font-size: 11px;
            color: #999999;

            img {
              width: 20px;
              height: 20px;
            }

            span {
              margin-left: 11px;
              font-weight: 600;
              font-size: 14px;
              color: #000000;
              line-height: 20px;
              letter-spacing: 0;
              margin-right: 6px;
            }
          }
        }

        .item-contactEditTxt {
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;

          .profilePicEdit {
            width: 6px;
            height: 10px;
            vertical-align: middle;
          }

          span {
            font-size: 12px;
            line-height: 16px;
            color: #4a90e2;
            letter-spacing: 0;
            text-align: right;
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }
    }

    .contactInfo {
      font-size: 13px;
      width: 100%;
      padding-bottom: 14px;

      .contactInfo-main {
        width: calc(100% - 59px);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .item-contactInput {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 8px 0;
        position: relative;
        gap: 6px;

        .item-contactInputTxt {
          -webkit-box-flex: 0;
          -webkit-flex: none;
          -moz-box-flex: 0;
          -ms-flex: none;
          //width: 106px;
          font-size: 12px;
          line-height: 20px;
          color: #4A4A4A;
        }

        input {
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -moz-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          width: 94px;
          height: 18px;
          padding: 0 0 4px 2px;
          margin-top: 4px;
          font-size: 12px;
          line-height: 18px;
          color: #333;
          -webkit-appearance: none;
          outline: none;
          border-bottom: 1px solid #4A4A4A;
          ;
          border-radius: 0;
          background-color: transparent;
        }

        .indentifyingCode {
          position: relative;
        }

        .contactPicCode {
          position: absolute;
          left: 145px;
          top: 50%;
          transform: translate(0, -50%);
        }

        .contactPhone {
          width: 50px;
        }

        .callingCode-text {
          max-width: 110px;
          background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg) no-repeat right transparent;
          border: 0;
          -moz-appearance: none;
          -webkit-appearance: none;
          padding-right: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          margin-right: 15px;
          margin-left: 5px;
        }

        select.callingCode-css {
          width: 140px;
          display: inline-block;
          border: none;
          font-size: 13px;
          text-indent: 10px;
          appearance: menulist-button;
          -webkit-appearance: menulist-button;
          -moz-appearance: menulist-button;
          font-weight: bold;
          opacity: 0;
          position: absolute;
          left: 50px;
          z-index: 2;
          width: 93px;
        }

        .send-verification {
          -webkit-box-flex: 0;
          -webkit-flex: none;
          -moz-box-flex: 0;
          -ms-flex: none;
          flex: none;
          width: 58px;
          height: 21px;
          border: 1px solid #4A90E2;
          font-weight: 500;
          font-size: 10px;
          color: #4A90E2;
          line-height: 18px;
          text-align: center;
          border-radius: 5px;
          position: absolute;
          left: 145px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }

      .noNeedPhone {
        width: 278px;

        & input {
          width: 100%;
        }
      }

      .item-saveContacts {
        width: 83px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: #FCC300;
        border-radius: 4px;
        font-weight: 600;
        font-size: 11px;
        color: #FFFFFF;
        margin: 5px auto 0;
      }
    }

    .contactInfoList {
      height: 23px;
      font-weight: 600;
      font-size: 11px;
      color: #333333;
      line-height: 16px;
      margin-bottom: 12px;

      .contact-main::-webkit-scrollbar {
        display: none;
      }

      .contact-main {
        display: flex;
        flex-wrap: nowrap;
        gap: 6px;
        overflow-x: scroll;
        width: 100%;

        .contact-item {
          white-space: nowrap;
          border: 1px solid rgba(0, 0, 0, 0);
          padding: 4px 9px;
          box-sizing: border-box;
          border-radius: 4px;
          background: #EEEEEE;
        }

        .selected {
          border: 1px solid #FCC300;
          background: #FFEFBA;
          position: relative;
        }

        .selectedImg {
          display: none;
        }

        .selected .selectedImg {
          display: block;
          width: 7px;
          height: 4px;
          position: absolute;
          top: 1px;
          right: 0;
          z-index: 9;

          img {
            display: block;
            width: 100%;
          }
        }

        .selected:after {
          content: '';
          width: 10px;
          height: 8px;
          background: #FCC300;
          border-bottom-left-radius: 3px;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1;
        }
      }
    }

    .contactInfo-filled {
      width: 100%;
      padding-bottom: 10px;

      .contactInfo-name {
        font-weight: 600;
        font-size: 12px;
        color: #000000;
        display: flex;
        gap: 10px;
      }

      .contactInfo-email {
        font-weight: 400;
        font-size: 11px;
        color: #000000;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .cruiseRoomsCon {
    padding-top: 14px;

    .cruiseRoomsCon-prompTitle {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      padding: 0 40px 14px 20px;
      text-align: center;

      img {
        width: 22px;
        height: 22px;
        margin-right: 5px;
      }

      span {
        font-size: 12px;
        line-height: 18px;
        color: #666;
        letter-spacing: 0;
        text-align: left;
      }
    }

    .cruiseRoomsCon-roomDetail {
      width: 340px;
      margin: 0 auto 8px;
      background-color: #fff;
      border-top: 5px solid #febc10;
      border-radius: 5px;
      -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      padding-bottom: 17px;

      .item-content {
        padding: 0.48rem 12px;
        border-bottom: 1px solid #eee;
      }

      .label-checkbox {
        padding-top: 0;
        padding-bottom: 0px;
      }

      .item-title-row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }

      .cruiseRoomsCon-roomTxt {
        line-height: 15px;
        font-weight: 600;
        font-size: 14px;
        color: #4A4A4A;
        margin-bottom: 4px;

        >div {
          text-align: right;
        }

        span {
          font-weight: bold;
        }

        span.cruiseRoomsNum {
          color: #333;
        }

        .item-roomDetailSee {
          display: inline-block;
          vertical-align: middle;
          width: 62px;
          height: 15px;
          margin-left: 2px;
          font-size: 11px;
          line-height: 15px;
          color: #fff;
          text-align: center;
          font-weight: normal;
          border-radius: 2px;
          background-color: #febc10;
          text-align: center;
        }
      }

      .roomDetail-resideInfo {
        .item-title-row {
          margin-top: 4px;

          .item-title.item-text {
            height: auto;
            font-size: 12px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
          }

          .item-after {
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;

            .roomDetail-deckTips {
              font-size: 12px;
              line-height: 14px;
              color: #4a90e2;
              padding-top: 2px;
            }

            .roomDetail-deckBtn {
              padding: 0 8px;
              font-size: 10px;
              line-height: 14px;
              color: #4a90e2;
              border: 1px solid #4a90e2;
              border-radius: 3px;
            }
          }
        }
      }

      .stateroomNumber {
        font-weight: 600;
        font-size: 12px;
        color: #4A4A4A;
        line-height: 17px;
        background: url("https://resource.rcclchina.com.cn/mobileSearchPackage/floor-bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        height: 28px;

        & .stateroomNumber-left {
          width: 18px;
          height: 18px;
          margin: 0 8px 0 4px;

          & img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        & .stateroomNumber-center {
          font-weight: 400;
          font-size: 11px;
          color: #4A4A4A;
          line-height: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          margin-right: 13px;

          & span {
            color: #4A4A4A;
            font-weight: bold;
            border-bottom: 1px solid #4A4A4A;
          }
        }

        & .stateroomNumber-right {
          display: flex;
          align-items: center;
          font-size: 11px;
          color: #006AB6;
          line-height: 16px;
          gap: 2px;

          & img {
            display: block;
            width: 6px;
            height: 10px;
          }
        }
      }

      .stateroomTips {
        font-weight: 400;
        font-size: 9px;
        color: #9B9B9B;
        line-height: 15px;
        padding: 1px 0;
      }

      .roomDetail-area {
        height: auto;
        margin-top: 2px;
        margin-bottom: 5px;
        line-height: 16px;
        font-size: 11px;
        color: #9B9B9B;
        letter-spacing: 0;
        font-weight: normal !important;
      }

      .roomDetail-tips {
        padding: 7px;
        background: #EEEEEE;
        font-size: 11px;
        color: #9B9B9B;
        line-height: 16px;

        p {
          margin: 0;
        }
      }

      .roomDetail-guestsInfo {
        padding-top: 6px;
        overflow: hidden;

        .roomDetail-guestsInfoDetail {
          border: 1px solid #4a90e2;
          position: relative;
          float: left;
          width: 73px;
          height: 66px;
          margin-left: 8px;
          margin-bottom: 0;
          border-radius: 2px;
          -webkit-border-radius: 2px;

          .roomDetail-guestsInfoTitle {
            width: 47px;
            text-align: center;
            color: #808080;
            position: absolute;
            top: -0.4559rem;
            font-size: 12px;
            background-color: #fff;
            left: 50%;
            transform: translateX(-50%);

            .guestOrderNum {
              color: #4a90e2;
            }
          }

          .roomDetail-guestsInfoOperate {
            text-align: center;

            .guestInfoPlusCon {
              line-height: 1;
            }

            .roomDetail-guestInfoEditBtn,
            .roomDetail-guestInfoPlusBtn {
              width: 39px;
              margin: 16px auto 0;

              &.isEmpty {
                margin-top: 13px;
              }
            }

            .roomDetail-guestInfoEditBtn .guestEditBtn,
            .roomDetail-guestInfoPlusBtn .guestPlusBtn {
              width: 15px;
              margin: 0 auto 0;

              &.isEmpty {
                margin-top: 2px;
              }
            }

            .guestVerify {
              margin-top: 2px;
              font-size: 12px;
              color: #808080;

              &.isRequired {
                color: #ff0000;
              }
            }

            .guestInfoPlusTxt {
              font-size: 12px;
              color: #4a90e2;

              &.isEmpty {
                margin-top: 2px;
              }
            }

            .roomDetail-guestInfoName {
              font-size: 12px;
              color: #333;
              width: 71px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .roomDetail-guestsInfoDetail:first-child {
          margin-left: 0;
        }
      }

      .roomDetail-passenger {
        .roomDetail-passenger-main {
          .title-desc {
            font-size: 11px;
            line-height: 16px;
            padding: 4px 12px 0;
            color: #999;
            & > span {
              color: #ff0000;
            }
          }
          .passenger-main-title {
            padding: 12px 12px 0;
            display: flex;
            justify-content: space-between;

            .title-tips {
              font-weight: 600;
              font-size: 14px;
              color: #000000;
              line-height: 20px;

              span {
                font-weight: 400;
                font-size: 11px;
                color: #999999;
                margin-left: 8px;
              }
            }

            .title-right {
              font-weight: 400;
              font-size: 11px;
              color: #4A90E2;
              display: flex;
              line-height: 16px;
              align-items: center;
              gap: 5px;

              img {
                width: 6px;
                height: 10px;
              }
            }
          }

          .contactInfoList {
            font-weight: 600;
            font-size: 11px;
            color: #333333;
            padding: 12px 12px 10px;

            .contact-main::-webkit-scrollbar {
              display: none;
            }

            .contact-main {
              line-height: 16px;
              display: flex;
              flex-wrap: nowrap;
              gap: 6px;
              overflow-x: scroll;
              width: 100%;

              .contact-item {
                white-space: nowrap;
                border: 1px solid rgba(0, 0, 0, 0);
                padding: 4px 9px;
                box-sizing: border-box;
                border-radius: 4px;
                background: #EEEEEE;
              }

              .selected {
                border: 1px solid #FCC300;
                background: #FFEFBA;
                position: relative;
              }

              .selectedImg {
                display: none;
              }

              .selected .selectedImg {
                display: block;
                width: 7px;
                height: 4px;
                position: absolute;
                top: 1px;
                right: 0;
                z-index: 9;

                img {
                  display: block;
                  width: 100%;
                }
              }

              .selected:after {
                content: '';
                width: 10px;
                height: 8px;
                background: #FCC300;
                border-bottom-left-radius: 3px;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
              }
            }
          }
        }

        .passenger-detail-desc {
          background: #fff;
          width: calc(100% - 49px);
        }

        .passenger-content:first-child {
          padding-top: 9px;
        }

        .passenger-content {
          position: relative;
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          width: 100%;
          padding: 15px 0 0;
          gap: 6px;

          .passenger-family,
          .passenger-txt {
            font-size: 12px;
            line-height: 20px;
            color: #333;

            input {
              border-bottom: 1px solid #4A4A4A !important;
            }
          }

          .passenger-txt input,
          .passenger-txt select {
            position: relative;
            z-index: 1;
            display: block;
            width: 100%;
            height: 20px;
            -webkit-appearance: none;
            outline: none;
            border: none;
            border-radius: 0;
            padding: 0;
            font-size: 12px;
            color: #4A4A4A;
            background-color: transparent;
          }

          .passenger-txt input::placeholder {
            color: #C1C1C1;
          }

          .passenger-family {
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -moz-box-flex: 0;
            -ms-flex: none;
            flex: none;
          }

          .passenger-txt {
            position: relative;

            .passenger-country {
              display: flex;
              flex: 1;
              min-width: 64px;
              padding-right: 20px;
              min-height: 19px;
              border-bottom: 1px solid #4A4A4A;
              position: relative;
              padding-left: 5px;
            }

            .passenger-arrow-right {
              position: absolute;
              right: 0;
              top: 0;
              width: 6px;
              height: 10px;

              img {
                width: 100%;
              }
            }
          }

          .passenger-title-short {
            //margin-right: 7px;
          }

          .passenger-male {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
          }

          .male-txt,
          .female-txt {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;

            span {
              margin-left: 3px;
            }

            img {
              width: 14px;
              height: 14px;
            }
          }

          .male-txt {
            margin-right: 12px;
          }

          .phone-css {
            width: 50px;
          }

          .callingCode-text {
            background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg) no-repeat right transparent;
            border: 0;
            -moz-appearance: none;
            -webkit-appearance: none;
            padding-right: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            margin-right: 15px;
            margin-left: 5px;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            max-width: 120px;
          }

          .callingCode-css {
            opacity: 0;
            position: absolute;
            left: 50px;
            z-index: 2;
            width: 93px;
          }

          .passportClearBtn {
            position: absolute;
            right: 0;
            top: 50%;
            z-index: 3;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            padding: 4px 3px;
            font-size: 12px;
            line-height: 1;
            color: #4A90E2;
            background: #fff;
            border-radius: 3px;
            border: 1px solid #4A90E2;
          }

          .send-verification {
            width: 42px;
            height: 21px;
            border: 1px solid #4A90E2;
            font-weight: 500;
            font-size: 10px;
            color: #4A90E2;
            line-height: 18px;
            text-align: center;
            border-radius: 5px;
            position: absolute;
            right: -49px;
            top: 50%;
            transform: translate(0, -50%);
          }
        }

        .passenger-birthDate {
          display: flex;
          flex-wrap: nowrap;
          gap: 6px;

          .birth-date {
            width: 90px !important;
          }
        }

        .passenger-sex {
          display: flex;
          align-items: center;

          .passenger-family {
            margin: 0 10px 0 20px;
          }
        }

        .guest-main {
          padding: 6px 12px 17px;
          border-bottom: 1px solid #eee;

          .guest-select-main {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 12px;
            color: #4A4A4A;

            .guest-select-checkbox {
              display: flex;
              align-items: center;
              gap: 3px;
              height: 16px;
              line-height: 16px;
              font-size: 11px;
              color: #999999;
              margin-left: 5px;

              img {
                width: 14px;
                height: 14px;
              }
            }

            .clearGuest {
              font-weight: 400;
              font-size: 11px;
              line-height: 16px;
              color: #4A90E2;
              margin-left: 8px;
            }
          }
        }

        .guest-main:last-child {
          padding-top: 16px;
          border-bottom: none;
          padding-bottom: 0;
        }
      }

      .roomDetail-infoFillTips {
        font-size: 12px;
        line-height: 1;

        &::before {
          display: none;
        }

        &::after {
          display: none;
        }

        &>li {
          overflow: hidden;
          margin-top: 6px;
          min-height: 14px;
          letter-spacing: -0.5px;

          &:first-child {
            margin-top: 10px;
          }

          &>img {
            float: left;
            display: block;
            height: 12px;
            margin-right: 4px;
            margin-top: 1px;
          }

          &>div {
            overflow: hidden;
            line-height: 1.4;

            &>span {
              font-weight: bold;
              padding: 0 4px;
            }

            &>em {
              font-style: normal;
            }
          }
        }
      }

      .coupon-item-inner {
        padding: 0 12px;
        border-top: 1px solid #EEEEEE;
        margin-top: 10px;

        .roomDetail-coupon {
          img {
            width: 20px;
            margin-right: 5px;
            vertical-align: middle;
          }

          span {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #4a90e2;
            font-weight: normal;
            letter-spacing: 0;
          }
        }

        .item-roomCoupon {
          font-size: 0.6rem;
          color: #0071a3;
          font-weight: normal !important;
          .coupon-toggle-arrow {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-top: 1px solid #0071a3;
            border-right: 1px solid #0071a3;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            vertical-align: -1px;
            position: relative;
            top: 5px;
          }
          .coupon-toggle-arrow.active {
            transform: rotate(135deg);
            -webkit-transform: rotate(135deg);
            vertical-align: 1px;
          }
        }

        .item-couponCon {
          margin-top: 8px;
          margin-bottom: 2px;
          padding: 14px 14px 14px 11px;
          background-color: #febc10;
          font-size: 12px;
          line-height: 16px;
          color: #fff;

          .item-couponSelectCon {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;

            .item-couponSelect {
              -webkit-box-flex: 1;
              -webkit-flex: 1;
              -moz-box-flex: 1;
              -ms-flex: 1;
              flex: 1;
              display: -webkit-box;
              display: -webkit-flex;
              display: -moz-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: center;
              -webkit-align-items: center;
              -moz-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              height: 16px;
              background-color: #fff;
              line-height: 16px;

              .item-couponSelists {
                display: block;
                width: 90%;
                height: 16px;
                padding: 0 0 0 8px;
                font-size: 11px;
                line-height: 16px;
                color: #333;
              }

              .coupon-select-arrow {
                display: block;
                width: 6px;
                height: 6px;
                margin-right: 6px;
                border-right: 1px solid #999;
                border-bottom: 1px solid #999;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
              }
            }
          }

          .item-activityNum {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-top: 9px;

            input {
              -webkit-box-flex: 1;
              -webkit-flex: 1;
              -moz-box-flex: 1;
              -ms-flex: 1;
              flex: 1;
              display: block;
              height: 16px;
              padding: 0 0 0 8px;
              background-color: #fff;
              border: none;
              font-size: 11px;
              line-height: 16px;
              color: #333;
            }
          }
        }
      }
    }

    .lookDeckImg {
      font-weight: 400;
      font-size: 12px;
      color: #4A90E2;
      padding: 14px 14px 0;
      display: flex;
      align-items: center;
      gap: 5px;
      border-top: 1px solid #eee;
      margin-top: 14px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .unsubscribeFree,
  .unsubscribePay {
    display: inline-block;
    vertical-align: middle;
    margin-left: 2px;
    padding: 0px 4px;
    height: 16px;
    font-weight: 400;
    font-size: 11px;
    color: #006AB6;
    line-height: 15px;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #4A90E2;
  }

  #c_connect_detail {
    //padding: 0 11px !important;
    border: 1px solid #febc10;
    background-color: #fff;
    border-top: 5px solid #febc10;
    overflow: hidden;
  }

  #c_connect_detail .c_img {
    width: 98px;
    height: 17px;
    margin-top: 6px;
  }

  #c_connect_detail .c_img_info {
    width: 100%;
    //margin-left: -12px;
  }

  .c_cutoff {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #eee;
    margin: 15px 0 8px;
    position: relative;
  }

  .c_cutoff:after {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #F5F5F5;
    position: absolute;
    top: -8px;
    right: -8px;
  }

  .c_cutoff:before {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #F5F5F5;
    position: absolute;
    top: -8px;
    left: -8px;
  }

  .notice-wrap {
    margin-top: 10px;
    margin-bottom: 10px;
    padding-bottom: 15px;
    background-color: #fff;

    .js_shorex {
      margin-bottom: 0;
      padding-bottom: 5px;
    }

    .notice-line {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      -moz-box-flex: 0;
      -ms-flex: none;
      flex: none;
      width: 3px;
      height: 14px;
      margin-right: 5px;
      background-color: #4a90e2;
      border-radius: 1px;
    }

    .notice-txt {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      font-size: 14px;
      line-height: 20px;
      color: #4a90e2;
      font-weight: 600;
    }

    .notice-arrow {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      -moz-box-flex: 0;
      -ms-flex: none;
      flex: none;
      width: 11px;
      -webkit-transform: rotate(-90deg);
      -moz-transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
      -o-transform: rotate(-90deg);
      transform: rotate(-90deg);
    }

    .active .notice-arrow {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  .notice {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
    padding: 17px 32px 14px 25px;
    background-color: #fff;

    img {
      max-width: 100%;
    }
  }

  .notice-item {
    margin: 0 15px 17px 25px;
    padding-left: 8px;
    border-bottom: 1px solid #cccccc;

    .no-shorex {
      font-size: 12px;
      color: #666;
    }

    .notice-item-title {
      margin-bottom: 6px;
      font-size: 14px;
      line-height: 20px;
      color: #4a90e2;
    }

    .notice-item-text {
      padding-bottom: 15px;
      font-size: 12px;
      line-height: 20px;
      color: #666;

      .visa_right__titlt {
        font-weight: bold;
        margin-top: 16px !important;
        color: #333 !important;
      }

      p {
        margin: 0;
      }
    }

    .shorex-item-title {
      font-size: 12px;
      color: #333333;
      margin-bottom: 10px;
    }

    .shorex-item-text {
      padding-bottom: 0px;

      p.shorex-item-name {
        font-size: 12px;
        color: #4a90e2;
        margin-bottom: 5px;
      }
    }
  }

  .notice-item:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }

  .notice-detail {
    height: 250px;
    overflow-y: auto;
  }
}
</style>

<style lang="less">
.shorex-item-trip,
.shorex-item-trip p,
.shorex-item-trip span {
  font-size: 12px !important;
  color: #333333 !important;
  font-weight: bold !important;
  margin: 0px;
}

.guestInfo {
  #stateroomDetail .blue {
    color: #4a90e2;
  }

  #bookingRuleDetail {
    margin-bottom: 0px;
  }

  .packageRuleDetail .rule-item:last-child {
    margin-bottom: 0px;
  }
}

.guest-header {
  width: 375px;
  height: 82.5px;
  text-align: center;
  color: #FFFFFF;
  font-size: 12px;
  padding-top: 10px;
  background-image: url("https://resource.rcclchina.com.cn/mobile/order/guest_info_top_bg.png");
  background-size: 100% 100%;

  & .logo {
    display: block;
    //width: 30px;
    height: 30px;
    margin: 0 auto;
  }

  & em {
    font-style: normal;
    font-size: 15px;
    font-weight: bold;
    margin: 0 3px;
  }

  & .row-0 {
    margin-top: 6px;
    font-size: 12px;

    &>span {
      display: inline-block;
      font-size: 15px;
      font-weight: bold;
      margin: 0 3px;
      padding: 0 2px 2px 2px;
      border-bottom: 1px solid #FFFFFF;
    }
  }

  &.is-tiktok {
    height: 96px;
    background-image: url("https://resource.rcclchina.com.cn/tikTok/mb/verification/guest_info_top_bg.jpg");
    background-size: 100% 100%;

    & .logo {
      margin-top: 2px;
    }

    & .row-1 {
      margin-top: 4px;
      line-height: 1;
      font-size: 12px;
      font-weight: bold;
    }

    & .row-2 {
      margin-top: 4px;
      line-height: 1;
      font-size: 10px;
    }
  }

  & .row-1 {
    margin-top: 4px;
    line-height: 1;
    font-size: 12px;
  }

  & .row-2 {
    margin-top: 3px;
    letter-spacing: -1px;
    line-height: 1;
    font-size: 12px;

    &>span {
      font-size: 15px;
      font-weight: bold;
      margin: 0 3px;
      letter-spacing: 0;
      padding: 0 2px;
      border-bottom: 1px solid #FFFFFF;
    }
  }
}

.tiktok-coupon-box {
  margin-top: 15px;

  & .title-box {
    display: flex;
    justify-content: flex-start;
    gap: 3px;

    & .icon {
      display: block;
      width: 16px;
      height: 16px;
    }

    & .text {
      position: relative;
      line-height: 1;
      font-size: 12px;
      font-weight: bold;
      padding: 0 3px;
      color: #000000;

      &>div {
        position: relative;
        z-index: 1;
        margin-top: 2px;
      }

      &::after {
        content: " ";
        position: absolute;
        bottom: 1px;
        left: 0;
        width: 100%;
        height: 4px;
        z-index: 0;
        background-color: #f9c500;
      }
    }
  }

  & .input-text {
    height: 23px;
    border-radius: 2.5px;
    width: 100%;
    padding: 0 3px;
    margin-top: 5px;
    border: 1px solid #000000;
  }
}

.QIAOHU_CSS {
  width: 113px;
  display: block;
  margin: 5px 0;
}

.STARRYSKY_CSS {
  width: 113px;
  display: block;
  margin: 5px 0;
}
.PCP_GIFT_THEME_CSS {
  width: 90px;
  display: block;
  margin: 5px 0;
}
.CUSTOM_THEME_CSS {
  width: 90px;
  display: block;
  margin: 5px 0;
}
body {
  overflow: initial !important;
}
</style>

